<template>
	<div style="font-size: 14px" class="dashboard">
		<!-- <template v-if="isDomLoading">
			<TaskSkeletonLoader />
		</template> -->
		<!-- :style="isDomLoading ? 'visibility: hidden; height: 1px' : ''" -->
		<div>
			<div
				:style="showMoreFilters ? 'position: relative;' : ''"
				v-if="viewType == '1'"
			>
				<el-card shadow="none" style="border-radius: 6px; margin-top: 5px">
					<div
						style="
							display: flex;
							width: 100%;
							align-items: center;
							flex-wrap: nowrap;
						"
					>
						<!-- <div
							style="
								flex: 0 0 14%;
								display: flex;
								align-items: center;
								margin-top: 30px;
							"
						>
							<span
								@click="viewBy = 'location'"
								:style="
									viewBy == 'location' ? 'color:#D26300;font-weight:550' : ''
								"
								style="cursor: pointer; margin-right: 10px"
							>
								Locations
							</span>
							<span> | </span>
						<span
							@click="viewBy = 'user'"
							:style="viewBy == 'user' ? 'color:#D26300;font-weight:550' : ''"
							style="cursor: pointer; margin-left: 10px"
						>
							Users
						</span>
						</div> -->
						<div style="flex: 0 0 25%; margin-top: 10px">
							<div
								style="
									display: flex;
									justify-content: space-between;
									align-items: center;
								"
							>
								<div style="margin-left: 10px">Location</div>
								<div style="display: flex; align-items: center">
									<span
										@click="selectedLocationType = 'location'"
										style="font-size: 13px; cursor: pointer; margin-left: 20px"
										:style="
											selectedLocationType == 'location'
												? 'text-decoration: underline;color:#d26300;font-weight:bolder'
												: 'color:#d26300;'
										"
									>
										All Locations
									</span>
									<span style="color: #d26300; margin: 0 10px"> | </span>
									<span
										@click="selectedLocationType = 'region'"
										style="font-size: 13px; cursor: pointer; margin-right: 10px"
										:style="
											selectedLocationType == 'region'
												? 'text-decoration: underline;color:#d26300;font-weight:bolder'
												: 'color:#d26300;'
										"
									>
										Region
									</span>
								</div>
							</div>
							<div>
								<el-cascader
									v-if="selectedLocationType == 'region'"
									popper-class="custom-cascader"
									style="
										width: 100%;
										margin-top: 5px;
										text-transform: capitalize;
									"
									placeholder="Select Locations"
									:options="locationItems"
									:props="{
										multiple: true,
										checkStrictly: true,
										expandTrigger: 'hover',
									}"
									v-model="locations"
									filterable
									clearable
									:collapse-tags="true"
									id="cascader"
									@change="listTotalAverageGraphData(0)"
								></el-cascader>
								<el-select
									v-if="selectedLocationType == 'location'"
									style="margin-top: 5px; text-transform: capitalize"
									class="select"
									v-model="locations"
									filterable
									:multiple="true"
									:clearable="true"
									placeholder="Select Locations"
									@change="listTotalAverageGraphData(0)"
									:collapse-tags="true"
								>
									<el-option
										v-for="(item, key) in allLocations"
										:key="key"
										:label="item.name"
										:value="item.id"
									>
									</el-option>
								</el-select>
							</div>
						</div>
						<div style="flex: 0 0 20%; margin-top: 10px; margin-left: 20px">
							<div style="margin-left: 10px">Date</div>
							<!-- <el-select
                            style="margin-top: 5px"
                            class="select"
                            v-model="dates"
                            filterable
                            placeholder="Select Dates"
                        >
                            <el-option
                                v-for="(item, key) in datesItems"
                                :key="key"
                                :label="item.name"
                                :value="item.id"
                            >
                            </el-option> 
                        </el-select> -->
							<el-date-picker
								ref="datePickerRef"
								style="margin-top: 5px"
								v-model="dates"
								:type="datePickerType"
								class="date"
								unlink-panels
								range-separator="-"
								start-placeholder="Start Date"
								end-placeholder="End Date"
								:picker-options="pickerOptions"
								@picker-change="handlePickerClose('1')"
								@change="handlePickerClose('1')"
							>
							</el-date-picker>
							<!-- <el-date-picker
                            ref="monthrange"
                            v-if="daterange == 'monthrange'"
                            style="margin-top: 5px"
                            v-model="dates"
                            type="monthrange"
                            class="date"
                            unlink-panels
                            range-separator="-"
                            start-placeholder="Start Date"
                            end-placeholder="End Date"
                            :picker-options="pickerOptions"
                            @picker-change="handlePickerClose"
                            :visible-sync="isDrawerOpen1"
                        >
                        </el-date-picker> -->
						</div>
						<div style="flex: 0 0 25%; margin-top: 10px; margin-left: 20px">
							<div style="margin-left: 10px">Project and Tasks</div>
							<el-select
								style="margin-top: 5px"
								class="select"
								v-model="projectsTasks"
								filterable
								placeholder="Select Project and Tasks"
								@change="get_next_actions()"
							>
								<el-option
									v-for="(item, key) in projectsTasksItems"
									:key="key"
									:label="item.name"
									:value="item.id"
								>
								</el-option>
							</el-select>
						</div>
						<div
							style="
								flex: 0 0 15%;
								font-size: 13px;
								display: flex;
								align-items: center;
								margin-top: 30px;
								margin-left: 20px;
							"
							@click="toggleMoreFilters"
						>
							<img
								style="width: 15px; margin-right: 5px"
								src="../../../../assets/icons/Filter.png"
							/>
							<div
								style="
									text-decoration: underline;
									color: #d26300;
									font-weight: bold;
									cursor: pointer;
								"
							>
								More Filters
							</div>
						</div>
					</div>
					<div style="margin-top: 10px">
						<el-tag
							v-for="tag in selectedFilters"
							:key="tag.name + 'id'"
							closable
							type="warning"
							style="margin-right: 5px"
							@close="resetSelection(tag)"
						>
							{{ tag.name }}
						</el-tag>
					</div>
					<div :style="overlayStyle" v-if="showMoreFilters"></div>
					<div v-if="showMoreFilters" :style="childStyle">
						<el-card
							shadow="none"
							style="width: 25%; padding: 0; margin: 0; border-radius: 5px"
						>
							<div style="display: flex; align-items: center">
								<div style="flex: 1">
									Filters ({{ selectedFilters.length }})
								</div>
								<div style="margin-left: auto">
									<el-button
										@click="clear_filters(1)"
										size="medium"
										icon="el-icon-close"
										type="text"
										style="color: red"
									></el-button>
								</div>
							</div>
							<hr
								style="width: 100%; margin: 10px 0; border: 1px solid #999999"
							/>

							<div style="margin-left: 10px; font-size: 13px">Category</div>
							<el-select
								style="margin-top: 5px; z-index: 99999999999999999 !important"
								class="select"
								v-model="category"
								filterable
								placeholder="Select Category"
								@change="getForms(category)"
								popper-class="custom-dropdown"
							>
								<el-option
									v-for="(item, key) in categoryItems"
									:key="key"
									:label="item.name"
									:value="item.id"
								>
								</el-option>
							</el-select>
							<div style="margin-left: 10px; font-size: 13px; margin-top: 10px">
								Form
							</div>
							<el-select
								style="margin-top: 5px"
								class="select"
								v-model="forms"
								filterable
								:placeholder="
									category == 'All' ? 'Select Category First' : 'Select Form'
								"
								popper-class="custom-dropdown"
								:disabled="category == 'All'"
								@change="getQuestions(forms)"
							>
								<el-option
									v-for="(item, key) in formItems"
									:key="key"
									:label="item.name"
									:value="item.id"
								>
								</el-option>
							</el-select>
							<div style="margin-left: 10px; font-size: 13px; margin-top: 10px">
								Question
							</div>
							<el-select
								style="margin-top: 5px; width: 100%"
								class="select one"
								v-model="question"
								filterable
								:placeholder="
									forms == 'All' ? 'Select Form First' : 'Select Question'
								"
								:disabled="forms == 'All' || forms == ''"
								popper-class="custom-dropdown"
								@change="checkCondition('Question', question)"
							>
								<el-option
									class="ns-one"
									v-for="(item, key) in questionItems"
									:key="key"
									:label="item.name"
									:value="item.id"
								>
								</el-option>
							</el-select>
							<div style="margin-left: 10px; font-size: 13px; margin-top: 10px">
								Designation
							</div>
							<el-select
								style="margin-top: 5px"
								class="select"
								v-model="designation"
								filterable
								placeholder="Select Designation"
								popper-class="custom-dropdown"
								@change="checkCondition('Designation', designation)"
							>
								<el-option
									v-for="(item, key) in designationItems"
									:key="key"
									:label="item.full_name"
									:value="item.id"
								>
								</el-option>
							</el-select>
							<div style="margin-left: 10px; font-size: 13px; margin-top: 10px">
								User
							</div>
							<el-select
								style="margin-top: 5px"
								class="select"
								v-model="user"
								filterable
								:placeholder="
									designation == 'All'
										? 'Select Designation First'
										: 'Select User'
								"
								popper-class="custom-dropdown"
								@change="checkCondition('User', user)"
							>
								<el-option
									v-for="(item, key) in userItems"
									:key="key"
									:label="item.full_name"
									:value="item.id"
								>
								</el-option>
							</el-select>
							<div style="margin-left: 10px; font-size: 13px; margin-top: 10px">
								Status
							</div>
							<el-select
								style="margin-top: 5px"
								class="select"
								v-model="status"
								filterable
								placeholder="Select Status"
								popper-class="custom-dropdown"
								@change="checkCondition('Status', status)"
							>
								<el-option
									v-for="(item, key) in statusItems"
									:key="key"
									:label="item.name"
									:value="item.id"
								>
								</el-option>
							</el-select>
							<div
								style="
									display: flex;
									justify-content: flex-end;
									margin-top: 15px;
									margin-bottom: -10px;
								"
							>
								<div
									style="
										text-decoration: underline;
										margin-top: 15px;
										color: #333333;
										cursor: pointer;
									"
									@click="clear_filters(2)"
								>
									clear
								</div>
								<div style="margin-left: 30px">
									<el-button @click="apply_filters()" class="button-class-new2">
										Apply Filter
									</el-button>
								</div>
							</div>
						</el-card>
					</div>
				</el-card>
				<el-card shadow="none" style="border-radius: 6px; margin-top: 5px">
					<div style="display: flex; justify-content: center">
						<div>
							<div style="font-weight: 600">Total</div>
							<div
								style="color: #d26300; font-weight: bold; cursor: pointer"
								@click="showSummaryDetails('total')"
							>
								{{ summaryData.total }}
							</div>
						</div>
						<div style="margin-left: 100px">
							<div style="font-weight: 600">Completed</div>
							<div
								@click="showSummaryDetails('completed')"
								style="color: #d26300; font-weight: bold; cursor: pointer"
							>
								{{ summaryData.completed }}
							</div>
						</div>
						<div style="margin-left: 100px">
							<div style="font-weight: 600">Pending</div>
							<div
								@click="showSummaryDetails('inprogress')"
								style="color: #d26300; font-weight: bold; cursor: pointer"
							>
								{{ summaryData.total - summaryData.completed }}
							</div>
						</div>
						<div style="margin-left: 100px">
							<div style="font-weight: 600">Average Score %</div>
							<div style="color: #d26300; font-weight: bold">
								{{
									showScore ? summaryData.completed_score_percentage + "%" : "-"
								}}
							</div>
						</div>
						<div style="margin-left: 100px">
							<div style="font-weight: 600">Completion %</div>
							<div style="color: #d26300; font-weight: bold">
								{{ (summaryData.completion_rate * 100).toFixed(2) }} %
							</div>
						</div>
						<div style="margin-left: 100px">
							<div style="font-weight: 600">Failed</div>
							<div
								@click="showSummaryDetails('fail')"
								style="color: #d26300; font-weight: bold; cursor: pointer"
							>
								{{ summaryData.failed_count }}
							</div>
						</div>
					</div>
				</el-card>
				<el-card
					v-loading="byLocationDataLoading"
					element-loading-text="Loading..."
					element-loading-spinner="el-icon-loading"
					style="border-radius: 6px; margin-top: 5px; height: 400px"
					shadow="none"
				>
					<div style="display: flex; width: 100%; margin-bottom: 0px">
						<div style="margin-left: 30px; width: 70%">
							<h3>By Location</h3>
						</div>
						<div style="width: 20%">
							<el-select
								class="select"
								style="margin-top: -5px"
								v-model="filterTotalAverage"
								filterable
								placeholder="Select"
								@change="listTotalAverageGraphData(0)"
							>
								<el-option
									v-for="(item, key) in filterTotalAverageItems"
									:key="key"
									:label="item.name"
									:value="item.id"
								>
								</el-option>
							</el-select>
						</div>
					</div>
					<div v-if="TotalAverageGraphData.length != 0">
						<DashboardSplitGraphVue
							:showGraph="showGraph"
							:TotalAverageGraphData="TotalAverageGraphData"
							:counryAverage="counryAverage"
							v-if="viewByLocation == 'Split'"
							@emitShowGraph="showGraph = false"
							:filterTotalAverage="filterTotalAverage"
							:SummaryreportsTable="SummaryreportsTable"
							:selectedLocationType="selectedLocationType"
							:is_bt="is_bt"
						/>
					</div>
					<div
						v-if="TotalAverageGraphData.length == 0 && !byLocationDataLoading"
					>
						<el-card style="border: none" shadow="none" class="no-data-card">
							<div class="no-data-text">No data found</div>
						</el-card>
					</div>
				</el-card>

				<div style="display: flex; width: 100%">
					<div style="width: 49.5%">
						<el-card
							v-loading="performanceByLocationDataLoading"
							element-loading-text="Loading..."
							element-loading-spinner="el-icon-loading"
							style="border-radius: 6px; margin-top: 5px; height: 375px"
							shadow="none"
						>
							<div style="display: flex; width: 100%; margin-bottom: 0px">
								<div style="margin-left: 30px; width: 70%">
									<h3>Performance - By Location</h3>
								</div>
								<div style="margin-left: 30px; width: 30%">
									<div style="display: flex; align-items: center">
										<span
											@click="viewByPerformance = 'Top'"
											:style="
												viewByPerformance == 'Top'
													? 'color:#D26300;font-weight:550'
													: ''
											"
											style="cursor: pointer; margin-right: 10px"
										>
											Top 5
										</span>
										<span> | </span>
										<span
											@click="viewByPerformance = 'Bottom'"
											:style="
												viewByPerformance == 'Bottom'
													? 'color:#D26300;font-weight:550'
													: ''
											"
											style="cursor: pointer; margin-left: 10px"
										>
											Bottom 5
										</span>
									</div>
								</div>
							</div>
							<div v-if="TotalByLocationData.length != 0">
								<DashboardPerformanceByLocationGraph
									:TotalByLocationData="TotalByLocationData"
									:showGraphByLocation="showGraphByLocation"
									@emitshowGraphByLocation="showGraphByLocation = false"
									:viewType="viewType"
									:showGraphByLocationexpanded="showGraphByLocationexpanded"
									@emitshowGraphByLocationexpanded="
										showGraphByLocationexpanded = false
									"
									:showScore="showScore"
									:showCompletion="showCompletion"
								/>
								<div
									style="
										display: flex;
										justify-content: flex-end;
										margin-right: 50px;
										text-decoration: underline;
										color: #d26300;
										cursor: pointer;
									"
									@click="getViewType('location')"
								>
									View More
								</div>
							</div>

							<div
								v-if="
									TotalByLocationData.length == 0 &&
									!performanceByLocationDataLoading
								"
							>
								<el-card
									style="border: none"
									shadow="none"
									class="no-data-card"
								>
									<div class="no-data-text">No data found</div>
								</el-card>
							</div>
						</el-card>
					</div>
					<div style="width: 1%"></div>
					<div style="width: 49.5%">
						<el-card
							v-loading="formsDataLoading"
							element-loading-text="Loading..."
							element-loading-spinner="el-icon-loading"
							style="border-radius: 6px; margin-top: 5px; height: 375px"
							shadow="none"
						>
							<div style="display: flex; width: 100%; margin-bottom: 0px">
								<div style="margin-left: 30px; width: 50%">
									<h3>Performance - By Forms</h3>
								</div>
							</div>
							<div v-if="TotalFormsData.length !== 0">
								<DashboardPerformanceByFormsGraph
									:showGraphByForms="showGraphByForms"
									:TotalFormsData="TotalFormsData"
									@emitshowGraphbyForms="showGraphByForms = false"
									:showScore="showScore"
									:showCompletion="showCompletion"
								/>
								<div
									style="
										display: flex;
										justify-content: flex-end;
										margin-right: 50px;
										text-decoration: underline;
										color: #d26300;
										cursor: pointer;
									"
									@click="getViewType('form')"
								>
									View More
								</div>
							</div>
							<div v-if="TotalFormsData.length === 0 && !formsDataLoading">
								<el-card
									style="border: none"
									shadow="none"
									class="no-data-card"
								>
									<div class="no-data-text">No data found</div>
								</el-card>
							</div>
						</el-card>
					</div>
				</div>
				<div v-if="showScore" style="display: flex; width: 100%">
					<div style="width: 49.5%">
						<el-card
							v-loading="criticalDataLoading"
							element-loading-text="Loading..."
							element-loading-spinner="el-icon-loading"
							style="border-radius: 6px; margin-top: 5px; height: 375px"
							shadow="none"
						>
							<div style="display: flex; width: 100%; margin-bottom: 0px">
								<div style="margin-left: 30px; width: 50%">
									<h3>Locations - Critical Questions Failed</h3>
								</div>
							</div>
							<div v-if="criticalQuestionsData.length != 0">
								<DashboardCriticalQuestionsGraph
									:showGraphbyCriticalQuestion="showGraphbyCriticalQuestion"
									:criticalQuestionsData="criticalQuestionsData"
									@emitshowGraphbyCriticalQuestion="
										showGraphbyCriticalQuestion = false
									"
									:showScore="showScore"
									:showCompletion="showCompletion"
								/>
								<div
									style="
										display: flex;
										justify-content: flex-end;
										margin-right: 50px;
										text-decoration: underline;
										color: #d26300;
										cursor: pointer;
									"
									@click="getViewType('critical')"
								>
									View More
								</div>
							</div>
							<div
								v-if="criticalQuestionsData.length == 0 && !criticalDataLoading"
							>
								<el-card
									style="border: none"
									shadow="none"
									class="no-data-card"
								>
									<div class="no-data-text">
										All Locations met critical standards
									</div>
								</el-card>
							</div>
						</el-card>
					</div>
					<div style="width: 1%"></div>
					<div style="width: 49.5%">
						<el-card
							v-loading="topNonDataLoading"
							element-loading-text="Loading..."
							element-loading-spinner="el-icon-loading"
							style="border-radius: 6px; margin-top: 5px; height: 375px"
							v-if="topNonComplaintsData.length != 0"
							shadow="none"
						>
							<TopNonCompliantTable
								:topNonComplaintsData="topNonComplaintsData"
								:viewType="viewType"
								@show_row_data="showInDetailsQue"
								:projectsTasks="projectsTasks"
								:projectsTasksItems="projectsTasksItems"
								:dates="dates"
								@checkTypeToggle="checkTypeToggleMethod"
							/>
							<div
								style="
									display: flex;
									justify-content: flex-end;
									margin-right: 50px;
									text-decoration: underline;
									color: #d26300;
									cursor: pointer;
								"
								@click="getViewType('compliant')"
							>
								View More
							</div>
						</el-card>
						<el-card
							style="border-radius: 6px; margin-top: 5px"
							shadow="none"
							v-if="topNonComplaintsData.length == 0 && !topNonDataLoading"
						>
							<div style="width: 65%; margin-top: 5px">
								<h3>Top Non Compliant Questions</h3>
							</div>
							<el-card style="border: none" shadow="none" class="no-data-card">
								<div class="no-data-text">No data found</div>
							</el-card>
						</el-card>
					</div>
				</div>
				<!-- Here -->
				<!-- <div>
					<el-card
						v-if="actionPlanData.length != 0"
						shadow="none"
						style="margin-top: 5px"
					>
						<ActionPlanTable
							:actionPlanData="actionPlanData"
							:viewType="viewType"
							@show_row_data="showInDetailsQue"
							:projectsTasks="projectsTasks"
							:projectsTasksItems="projectsTasksItems"
							:dates="dates"
							@checkTypeToggle="checkTypeToggleMethod"
						/>
						<div
							style="
								display: flex;
								justify-content: flex-end;
								margin-right: 50px;
								text-decoration: underline;
								color: #d26300;
								cursor: pointer;
							"
						>
							View More
						</div>
					</el-card>
					<el-card
						style="border-radius: 6px; margin-top: 5px"
						shadow="none"
						v-if="actionPlanData.length == 0"
					>
						<div style="width: 65%; margin-top: 5px">
							<h3>Action Plan</h3>
						</div>
						<el-card style="border: none" shadow="none" class="no-data-card">
							<div class="no-data-text">No data found</div>
						</el-card>
					</el-card>
				</div> -->
				<el-card
					v-loading="reportsDataLoading"
					element-loading-text="Loading..."
					element-loading-spinner="el-icon-loading"
					style="border-radius: 6px; margin-top: 5px; height: 600px"
					shadow="none"
				>
					<el-row>
						<el-col :span="11">
							<span style="font-weight: bold">
								Reports -
								{{
									projectsTasksItems.length != 0
										? projectsTasksItems.filter((el) =>
												el.id.includes(projectsTasks)
										  )[0].name
										: "-"
								}}
								<br />
								( {{ moment(this.dates[0]).format("Do MMM YYYY") }} -
								{{ moment(this.dates[1]).format("Do MMM YYYY") }} )</span
							>
						</el-col>

						<el-col :span="5" style="margin-left: 20px">
							<input
								type="text"
								v-model="search"
								:placeholder="`Search ${
									selectedLocationType == 'region'
										? regionType == 0
											? 'Region'
											: regionType == 1
											? 'Sub Region'
											: 'Outlet'
										: 'Location'
								}`"
								class="searchicon"
							/>
						</el-col>
						<el-col :span="4" style="margin-left: 20px">
							<el-select
								class="select"
								v-model="report_type"
								filterable
								placeholder="Select Report Type"
								@change="listReportsSwitchData"
							>
								<el-option value="Consolidated Report">
									Consolidated Report
								</el-option>
								<el-option value="Project / Task - Breakup Report"
									>Project / Task - Breakup Report
								</el-option>
								<el-option value="Detailed Report"> Detailed Report </el-option>
							</el-select>
						</el-col>
						<el-col :span="3">
							<el-button
								icon="el-icon-download"
								style="margin-top: 0px; margin-left: 20px"
								class="button-class-new"
								@click="exportCSV(1)"
								:disabled="
									report_type == 'Consolidated Report'
										? reportsTable.length == 0
										: reportsTable1.length == 0
								"
							>
								Download Reports
							</el-button>
						</el-col>
					</el-row>
					<div v-if="report_type == 'Consolidated Report'">
						<ConsolidatedViewTable
							v-if="reportsTable.length != 0"
							:showCompletion="showCompletion"
							:showScore="showScore"
							:SummaryreportsTable="SummaryreportsTable"
							:reportsTable="reportsTable"
							:selectedLocationType="selectedLocationType"
							:viewBy="viewBy"
							:search="search"
							:viewType="viewType"
							:dates="dates"
							:projectsTasks="projectsTasks"
							:projectsTasksItems="projectsTasksItems"
							:category="category"
							:forms="forms"
							:locations="locations"
							:is_outlet="is_outlet"
							@showViewType4="getNextActions"
							:storeObject="storeObject"
							:is_bt="is_bt"
							:regionType="regionType"
							:status="status"
						/>
						<div v-if="reportsTable.length == 0">
							<el-card style="border: none" shadow="none" class="no-data-card">
								<div class="no-data-text">No data found</div>
							</el-card>
						</div>
					</div>

					<div v-if="report_type == 'Project / Task - Breakup Report'">
						<ProjectsTasksViewTable
							v-if="reportsTable1.length != 0"
							:showCompletion="showCompletion"
							:showScore="showScore"
							:reportsTable1="reportsTable1"
							:viewBy="viewBy"
							:search="search"
						/>
						<div v-if="reportsTable1.length == 0">
							<el-card style="border: none" shadow="none" class="no-data-card">
								<div class="no-data-text">No data found</div>
							</el-card>
						</div>
					</div>
				</el-card>
				<DetailedReportPopup
					:DialogDetailedReport="DialogDetailedReport"
					:all_locations="allLocations"
					:project_tasks="projectsTasks"
					:project_tasksItems="projectsTasksItems"
					@close="get_detailed_report_actions"
					@closed="get_detailed_report_actions"
					:locations="locations"
					:from_date="dates[0]"
					:to_date="dates[1]"
				/>
			</div>
			<div v-if="viewType == '2'">
				<div style="display: flex; justify-content: flex-start">
					<div>
						<img
							width="30px"
							src="../../../../assets/icons/Back Arrow.png"
							style="cursor: pointer"
							@click="getViewTypeOne()"
						/>
					</div>
					<div
						style="
							margin-top: 0px;
							color: #999999;
							margin-top: 5px;
							font-size: 16px;
							cursor: pointer;
						"
						@click="getViewTypeOne()"
					>
						Back
					</div>
				</div>
				<div style="margin-top: 5px; margin-bottom: 5px; margin-left: 5px">
					<h2>
						Performance - By Location
						{{ viewByPerformance == "Top" ? "( Top 5 )" : "( Bottom 5 )" }}
					</h2>
				</div>
				<!-- <el-card shadow="none">
				<div style="display: flex; width: 100%">
					<div style="width: 20%">
						<div style="margin-left: 10px">Date</div>
						<el-date-picker
							ref="datePickerRef"
							style="margin-top: 5px"
							v-model="dates"
							:type="datePickerType"
							class="date"
							unlink-panels
							range-separator="-"
							start-placeholder="Start Date"
							end-placeholder="End Date"
							:picker-options="pickerOptions"
							@change="handlePickerClose('2')"
						>
						</el-date-picker>
					</div>
				</div>
			</el-card> -->
				<el-card
					v-loading="performanceByLocationDataLoading"
					element-loading-text="Loading..."
					element-loading-spinner="el-icon-loading"
					style="border-radius: 6px; margin-top: 5px; height: 375px"
					shadow="none"
				>
					<DashboardPerformanceByLocationGraph
						:TotalByLocationData="TotalByLocationData"
						:showGraphByLocation="showGraphByLocation"
						@emitshowGraphByLocation="showGraphByLocation = false"
						:viewType="viewType"
						:showGraphByLocationexpanded="showGraphByLocationexpanded"
						@emitshowGraphByLocationexpanded="
							showGraphByLocationexpanded = false
						"
						:showScore="showScore"
						:showCompletion="showCompletion"
					/>
				</el-card>
				<el-card
					v-loading="performanceByLocationDataLoading"
					element-loading-text="Loading..."
					element-loading-spinner="el-icon-loading"
					style="border-radius: 6px; margin-top: 5px; height: 600px"
					shadow="none"
				>
					<div style="display: flex; width: 100%">
						<div style="width: 60%">
							<div
								style="margin-top: 5px; margin-bottom: 5px; margin-left: 5px"
							>
								<h2>
									Performance - By Location
									{{
										viewByPerformance == "Top" ? "( Top 5 )" : "( Bottom 5 )"
									}}
								</h2>
							</div>
						</div>
						<div style="width: 20%">
							<input
								type="text"
								v-model="search"
								:placeholder="`Search ${
									viewBy == 'location' ? 'Location' : 'User'
								}`"
								class="searchicon"
							/>
						</div>
						<div style="width: 20%">
							<el-button
								icon="el-icon-download"
								style="margin-top: 0px; margin-left: 20px"
								class="button-class-new"
								@click="exportCSV(2)"
							>
								Download Reports
							</el-button>
						</div>
					</div>
					<ConsolidatedViewTable
						:showCompletion="showCompletion"
						:showScore="showScore"
						:SummaryreportsTable="SummaryreportsTable"
						:reportsTable="reportsTable"
						:selectedLocationType="selectedLocationType"
						:viewBy="viewBy"
						:search="search"
						:viewType="viewType"
						:status="status"
						:regionType="regionType"
					/>
				</el-card>
			</div>
			<div v-if="viewType == '3'">
				<div style="display: flex; justify-content: flex-start">
					<div>
						<img
							width="30px"
							src="../../../../assets/icons/Back Arrow.png"
							style="cursor: pointer"
							@click="getViewTypeOne()"
						/>
					</div>
					<div
						style="
							margin-top: 0px;
							color: #999999;
							margin-top: 5px;
							font-size: 16px;
							cursor: pointer;
						"
						@click="getViewTypeOne()"
					>
						Back
					</div>
				</div>
				<div style="margin-top: 5px; margin-bottom: 5px; margin-left: 5px">
					<h2>Performance - By Forms</h2>
				</div>
				<!-- <el-card shadow="none">
				<div style="display: flex; width: 100%">
					<div style="width: 20%">
						<div style="margin-left: 10px">Date</div>
						<el-date-picker
							ref="datePickerRef"
							style="margin-top: 5px"
							v-model="dates"
							:type="datePickerType"
							class="date"
							unlink-panels
							range-separator="-"
							start-placeholder="Start Date"
							end-placeholder="End Date"
							:picker-options="pickerOptions"
							@change="handlePickerClose('3')"
						>
						</el-date-picker>
					</div>
				</div>
			</el-card> -->
				<el-card
					v-loading="formsDataLoading"
					element-loading-text="Loading..."
					element-loading-spinner="el-icon-loading"
					style="border-radius: 6px; margin-top: 5px; height: 375px"
					shadow="none"
				>
					<div style="display: grid">
						Region
						<el-select
							style="margin-top: 5px; width: 20%"
							class="select"
							v-model="regionToggle"
							filterable
							placeholder="Select View"
							popper-class="custom-dropdown"
							@change="changeRegion()"
						>
							<el-option
								v-for="(item, key) in regionListItem"
								:key="key"
								:label="item.name"
								:value="item.id"
							>
							</el-option>
						</el-select>
					</div>
					<DashboardPerformanceByFormsGraph
						:showGraphByForms="showGraphByForms"
						:TotalFormsData="TotalFormsData"
						@emitshowGraphbyForms="showGraphByForms = false"
						:showScore="showScore"
						:showCompletion="showCompletion"
					/>
				</el-card>
				<el-card
					v-loading="formsDataLoading"
					element-loading-text="Loading..."
					element-loading-spinner="el-icon-loading"
					style="border-radius: 6px; margin-top: 5px; height: 650px"
					shadow="none"
				>
					<PerformanceByFormsTable
						:PerformanceFormsData="PerformanceFormsData"
						:tableData="tableData"
						:all_location_list="all_location_list"
						:viewBy="viewBy"
						:search="search"
						:FormsSummary="FormsSummary"
					/>
				</el-card>
			</div>
			<div v-if="viewType == '4'">
				<div style="display: flex; justify-content: flex-start">
					<div>
						<img
							width="30px"
							src="../../../../assets/icons/Back Arrow.png"
							style="cursor: pointer"
							@click="getViewTypeOne()"
						/>
					</div>
					<div
						style="
							margin-top: 0px;
							color: #999999;
							margin-top: 5px;
							font-size: 16px;
							cursor: pointer;
						"
						@click="getViewTypeOne()"
					>
						Back
					</div>
				</div>
				<ReportsDashboardMoM_QoQ
					:storeObj="currentStoreObject"
					@clicked="get_dashboard_response_MoMQoQ"
					:current_view="'page_3'"
					:from_date="dates[0]"
					:to_date="dates[1]"
					:project_tasksItems="projectsTasksItems"
					:project_tasks="projectsTasks"
					:view_by="viewBy"
					:show_fields="showFields"
					:is_outlet="is_outlet"
					:is_bt="is_bt"
					:status="status"
					:showScore="showScore"
					:showCompletion="showCompletion"
				/>
			</div>
			<div v-if="viewType == '5'">
				<div style="display: flex; justify-content: flex-start">
					<div>
						<img
							width="30px"
							src="../../../../assets/icons/Back Arrow.png"
							style="cursor: pointer"
							@click="
								checkTypeToggleValue == '1'
									? getViewTypeOne()
									: (viewType = '7')
							"
						/>
					</div>
					<div
						style="
							margin-top: 0px;
							color: #999999;
							margin-top: 5px;
							font-size: 16px;
							cursor: pointer;
						"
						@click="
							checkTypeToggleValue == '1' ? getViewTypeOne() : (viewType = '7')
						"
					>
						Back
					</div>
				</div>
				<QueDetailsView
					:storeObj="storeObj"
					:from_date="dates[0]"
					:to_date="dates[1]"
					:topNonComplaintsData="topNonComplaintsData"
					@changeQuestion="changeQuestionMethod"
					:project_tasksItems="projectsTasksItems"
					:project_tasks="projectsTasks"
				/>
			</div>
			<div v-if="viewType == '6'">
				<div style="display: flex; justify-content: flex-start">
					<div>
						<img
							width="30px"
							src="../../../../assets/icons/Back Arrow.png"
							style="cursor: pointer"
							@click="getViewTypeOne()"
						/>
					</div>
					<div
						style="
							margin-top: 0px;
							color: #999999;
							margin-top: 5px;
							font-size: 16px;
							cursor: pointer;
						"
						@click="getViewTypeOne()"
					>
						Back
					</div>
				</div>
				<SummaryDetailedView
					:storeObj="storeObj"
					:from_date="dates[0]"
					:to_date="dates[1]"
					:topNonComplaintsData="topNonComplaintsData"
					@changeQuestion="changeQuestionMethod"
					:project_tasksItems="projectsTasksItems"
					:project_tasks="projectsTasks"
					:category="category"
					:designation="designation"
					:user="user"
					:status="status"
					:question="question"
					:forms="forms"
					:locations="locations"
					:is_outlet="is_outlet"
					:selectedLocationType="selectedLocationType"
					:locationItems="locationItems"
					:showScore="showScore"
					:showCompletion="showCompletion"
				/>
			</div>
			<div v-if="viewType == '7'">
				<div style="display: flex; justify-content: flex-start">
					<div>
						<img
							width="30px"
							src="../../../../assets/icons/Back Arrow.png"
							style="cursor: pointer"
							@click="getViewTypeOne()"
						/>
					</div>
					<div
						style="
							margin-top: 0px;
							color: #999999;
							margin-top: 5px;
							font-size: 16px;
							cursor: pointer;
						"
						@click="getViewTypeOne()"
					>
						Back
					</div>
				</div>
				<TopNonCompliantTable
					:topNonComplaintsData="topNonComplaintsData"
					:viewType="viewType"
					@show_row_data="showInDetailsQue"
					:projectsTasks="projectsTasks"
					:projectsTasksItems="projectsTasksItems"
					:dates="dates"
					@checkTypeToggle="checkTypeToggleMethod"
				/>
			</div>
			<div v-if="viewType == '8'">
				<div style="display: flex; justify-content: flex-start">
					<div>
						<img
							width="30px"
							src="../../../../assets/icons/Back Arrow.png"
							style="cursor: pointer"
							@click="getViewTypeOne()"
						/>
					</div>
					<div
						style="
							margin-top: 0px;
							color: #999999;
							margin-top: 5px;
							font-size: 16px;
							cursor: pointer;
						"
						@click="getViewTypeOne()"
					>
						Back
					</div>
				</div>
				<div style="margin-top: 5px; margin-bottom: 5px; margin-left: 5px">
					<h2>Locations - Critical Questions Failed</h2>
				</div>
				<el-card
					v-loading="criticalDataLoading"
					element-loading-text="Loading..."
					element-loading-spinner="el-icon-loading"
					style="border-radius: 6px; margin-top: 5px; height: 375px"
					shadow="none"
				>
					<DashboardCriticalQuestionsGraph
						:showGraphbyCriticalQuestion="showGraphbyCriticalQuestion"
						:criticalQuestionsData="criticalQuestionsData"
						@emitshowGraphbyCriticalQuestion="
							showGraphbyCriticalQuestion = false
						"
						:showScore="showScore"
						:showCompletion="showCompletion"
					/>
				</el-card>
				<el-card
					v-loading="criticalDataLoading"
					element-loading-text="Loading..."
					element-loading-spinner="el-icon-loading"
					style="border-radius: 6px; margin-top: 5px; height: 375px"
					shadow="none"
				>
					<CriticalQuestionsTable
						:criticalQuestionsData="criticalQuestionsData"
						:criticalQueFailedSummaryData="criticalQueFailedSummaryData"
						:projectsTasks="projectsTasks"
						:projectsTasksItems="projectsTasksItems"
						:dates="dates"
						@getLocationDetailsPage="getLocationDetailsPageMethod"
					/>
				</el-card>
			</div>
			<div v-if="viewType == '9'">
				<div style="display: flex; justify-content: flex-start">
					<div>
						<img
							width="30px"
							src="../../../../assets/icons/Back Arrow.png"
							style="cursor: pointer"
							@click="getViewTypeEight()"
						/>
					</div>
					<div
						style="
							margin-top: 0px;
							color: #999999;
							margin-top: 5px;
							font-size: 16px;
							cursor: pointer;
						"
						@click="getViewTypeEight()"
					>
						Back
					</div>
				</div>
				<div style="margin-top: 5px; margin-bottom: 5px; margin-left: 5px">
					<h2>
						Critical Questions Failed - {{ storeObj.name }} (
						{{ moment(this.dates[0]).format("Do MMM YYYY") }} -
						{{ moment(this.dates[1]).format("Do MMM YYYY") }} )
					</h2>
				</div>
				<el-card
					v-loading="topNonDataLoading"
					element-loading-text="Loading..."
					element-loading-spinner="el-icon-loading"
					style="border-radius: 6px; margin-top: 5px; height: 375px"
					shadow="none"
				>
					<ByLocationCriticalQuestionTable
						:ByLocationCriticalQuestionData="ByLocationCriticalQuestionData"
						:projectsTasks="projectsTasks"
						:projectsTasksItems="projectsTasksItems"
						:dates="dates"
						:storeObj="storeObj"
						@showPreviewByLocationAttachments="
							showPreviewByLocationAttachmentsMethods
						"
					/>
				</el-card>
			</div>
			<div v-if="viewType == '10'">
				<div style="display: flex; justify-content: flex-start">
					<div>
						<img
							width="30px"
							src="../../../../assets/icons/Back Arrow.png"
							style="cursor: pointer"
							@click="viewType = '9'"
						/>
					</div>
					<div
						style="
							margin-top: 0px;
							color: #999999;
							margin-top: 5px;
							font-size: 16px;
							cursor: pointer;
						"
						@click="viewType = '9'"
					>
						Back
					</div>
				</div>
				<div style="margin-top: 5px; margin-bottom: 5px; margin-left: 5px">
					<h3>
						Attachments for Question -
						{{
							storeObjImage.form_question_execution_info &&
							storeObjImage.form_question_execution_info.form_question_info
								? storeObjImage.form_question_execution_info.form_question_info
										.name
								: ""
						}}
					</h3>
				</div>
				<el-card shadow="none" style="margin-top: 5px">
					<PreviewByLocationAttachments
						:previewByLocationAttachmentsDialog="
							previewByLocationAttachmentsDialog
						"
						:fileURLArray="fileURLArray"
					/>
				</el-card>
			</div>
		</div>
	</div>
</template>

<script>
import formBuilderServices from "../../../../services/formBuilderServices";
import DashboardSplitGraphVue from "./DashboardSplitGraph.vue";
import DashboardPerformanceByLocationGraph from "./DashboardPerformanceByLocationGraph.vue";
import DashboardPerformanceByFormsGraph from "./DashboardPerformanceByFormsGraph.vue";
import DashboardConsolidatedGraph from "./DashboardConsolidatedGraph.vue";
import ConsolidatedViewTable from "./ConsolidatedViewTable.vue";
import ProjectsTasksViewTable from "./ProjectsTasksViewTable.vue";
import DetailedReportPopup from "./DetailedReportPopup.vue";
import PerformanceByFormsTable from "./PerformanceByFormsTable.vue";
import QueDetailsView from "./QueDetailsView.vue";
import SummaryDetailedView from "./SummaryDetailedView.vue";
import { mapState, mapActions } from "vuex";
import exportFromJSON from "export-from-json";
import ReportsDashboardMoM_QoQ from "./ReportsDashboardMoM_QoQ.vue";
import TaskSkeletonLoader from "../../labourPlaninig/tasks/taskSkeletonLoader.vue";
import TopNonCompliantTable from "./TopNonCompliantTable.vue";
import ActionPlanTable from "./ActionPlanTable.vue";
import DashboardCriticalQuestionsGraph from "./DashboardCriticalQuestionsGraph.vue";
import CriticalQuestionsTable from "./CriticalQuestionsTable.vue";
import ByLocationCriticalQuestionTable from "./ByLocationCriticalQuestionTable.vue";
var moment = require("moment");
import PreviewByLocationAttachments from "./PreviewByLocationAttachments.vue";

export default {
	props: {
		company_details: Object,
	},
	components: {
		DashboardSplitGraphVue,
		DashboardPerformanceByLocationGraph,
		DashboardPerformanceByFormsGraph,
		DashboardConsolidatedGraph,
		ConsolidatedViewTable,
		ProjectsTasksViewTable,
		DetailedReportPopup,
		PerformanceByFormsTable,
		QueDetailsView,
		SummaryDetailedView,
		ReportsDashboardMoM_QoQ,
		TaskSkeletonLoader,
		TopNonCompliantTable,
		DashboardCriticalQuestionsGraph,
		CriticalQuestionsTable,
		ByLocationCriticalQuestionTable,
		PreviewByLocationAttachments,
		ActionPlanTable,
	},
	data() {
		return {
			viewType: "1",
			showFailedQueGraph: true,
			isShowDetailedQue: false,
			isShowSummaryDetails: false,
			is_non_comp_que_extended: false,
			moment: moment,
			viewBy: "location",
			locations: [],
			allLocations: [],
			selectedLocationType: "location",
			dates: [],
			datesItems: [
				{ name: "Month To Date", id: "month_to_date" },
				{ name: "Week To Date", id: "week_to_date" },
				{ name: "Quarter To Date", id: "quarter_to_date" },
				{ name: "Year To Date", id: "year_to_date" },
				{ name: "Last Month", id: "last_month" },
				{ name: "Last Quarter", id: "last_quarter" },
				{ name: "Month On Month", id: "month_on_month" },
				{ name: "Quarter On Quarter", id: "quarter_on_quarter" },
				{ name: "Custom Dates", id: "custom_date" },
			],
			pickerOptions: {
				firstDayOfWeek: 1,
				shortcuts: [
					{
						text: "Month To Date",
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setDate(1);
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: "Last 7 Days",
						onClick(picker) {
							const end = new Date(); // Current date and time
							const start = new Date(); // Current date and time
							start.setDate(start.getDate() - 6); // Set the start date to 6 days ago (7 days including today)
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: "Week To Date",
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							const firstDayOfWeek = 0;
							const diff = start.getDay() - firstDayOfWeek;
							start.setDate(start.getDate() - diff);
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: "Quarter To Date",
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							const currentMonth = start.getMonth(); // Get the current month (0-11)
							let quarterStartMonth;
							if (currentMonth >= 0 && currentMonth <= 2) {
								quarterStartMonth = 0; // January
							} else if (currentMonth >= 3 && currentMonth <= 5) {
								quarterStartMonth = 3; // April
							} else if (currentMonth >= 6 && currentMonth <= 8) {
								quarterStartMonth = 6; // July
							} else {
								quarterStartMonth = 9; // October
							}
							start.setMonth(quarterStartMonth);
							start.setDate(1);

							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: "Year To Date",
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setMonth(0);
							start.setDate(1);
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: "Last Week",
						onClick(picker) {
							const today = new Date();
							const end = new Date(today.getTime() - today.getDay() * 86400000); // Calculate last Sunday
							const start = new Date(end.getTime() - 6 * 86400000); // Calculate Monday of last week

							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: "Last Month",
						onClick(picker) {
							const end = new Date(); // Current date and time
							const start = new Date(); // Current date and time

							// Set end date to the last day of the previous month
							end.setMonth(end.getMonth(), 0); // Set to last day of previous month

							// Set start date to the first day of the previous month
							start.setMonth(start.getMonth() - 1); // Move one month back
							start.setDate(1); // Set the date to 1st of the month

							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: "Last Quarter",
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit("pick", [start, end]);
						},
					},
					// {
					// 	text: "Month On Month (MOM)",
					// 	onClick: (picker) => {
					// 		this.onClickHandler(picker);
					// 	},
					// },
					// {
					// 	text: "Quarter on Quarter (QOQ)",
					// 	onClick(picker) {
					// 		// Set the type to month
					// 		// picker.$emit('pick', [null, null]); // Clear current selection to change type
					// 	},
					// },
					// {
					// 	text: "Custom Dates",
					// 	onClick(picker) {
					// 		// Set the type to month
					// 		// picker.$emit('pick', [null, null]); // Clear current selection to change type
					// 	},
					// },
				],
			},
			projectsTasks: "",
			projectsTasksItems: [],
			showMoreFilters: false,
			category: "",
			categoryItems: [],
			forms: "",
			formItems: [],
			question: "",
			questionItems: [],
			designation: "All",
			designationItems: [],
			user: "All",
			userItems: [],
			status: "All",
			statusItems: [
				{ name: "All", id: "All" },
				{ name: "Pending", id: "inprogress" },
				{ name: "Completed", id: "completed" },
			],
			isDrawerOpen: false,
			isDrawerOpen1: false,
			isMonthType: false,
			datePickerType: "daterange",
			viewByPerformance: "Top",
			viewByLocation: "Split",
			locationItems: [],
			showFields: [],
			showCompletion: false,
			TotalAverageGraphData: [],
			summaryData: {},
			counryAverage: null,
			showGraph: false,
			TotalByLocationData: [],
			showGraphByLocation: false,
			showGraphByForms: false,
			TotalFormsData: [],
			topNonComplaintsData: [],
			reportsTable: [],
			report_type: "Consolidated Report",
			isloading: false,
			SummaryreportsTable: [],
			showCompletion: false,
			search: "",
			showScore: false,
			reportsTable1: [],
			TotalCountryData: [],
			showGraphByCountry: false,
			showProjTasks: false,
			DialogDetailedReport: false,
			showGraphByLocationexpanded: false,
			PerformanceFormsData: [],
			all_location_list: [],
			tableData: [],
			FormsSummary: [],
			selectedFilters: [],
			filterTotalAverage: "",
			filterTotalAverageItems: [
				{ name: "Completed", id: "completed" },
				{ name: "Average Score %", id: "average" },
				{ name: "Score", id: "score" },
				{ name: "Total", id: "total" },
				{ name: "Completion %", id: "completion" },
			],
			mountType: false,
			is_outlet: false,
			currentStoreObject: {},
			storeObject: {},
			storeObj: {},
			is_bt: false,
			is_active: "1",
			regionToggle: "All",
			regionListItem: [],
			userItems1: [],
			regionType: null,
			isDomLoading: false,
			formsDataLoading: true,
			comingFrom5: false,
			checkTypeToggleValue: null,
			showGraphbyCriticalQuestion: false,
			criticalQuestionsData: [],
			ByLocationCriticalQuestionData: [],
			criticalQueFailedData: [],
			criticalQueFailedSummaryData: [],
			storeObjImage: {},
			previewByLocationAttachmentsDialog: false,
			fileURLArray: [],
			actionPlanData: [],
			byLocationDataLoading: false,
			performanceByLocationDataLoading: false,
			criticalDataLoading: false,
			topNonDataLoading: false,
			reportsDataLoading: false,
		};
	},
	watch: {
		// dates() {
		// 	this.listTotalAverageGraphData();
		// },
		selectedLocationType(val) {
			this.locations = [];
			this.listTotalAverageGraphData(0);
		},
		viewByLocation(val) {
			if (val == "Split") this.listTotalAverageGraphData(0);
			if (val == "Consolidated") this.listConsolidatedData();
		},
		viewByPerformance() {
			this.listByLocationData("only_five");
			// this.listTotalAverageGraphData(0);
		},
		viewType(val) {
			// localStorage.setItem("set_ViewType", val);
			this.$emit("get_ViewType", val);
		},
	},
	computed: {
		overlayStyle() {
			return this.showMoreFilters
				? {
						position: "absolute",
						top: 0,
						left: 0,
						width: "100%",
						height: "100%",
						backgroundColor: "rgba(0, 0, 0, 0.1)",
						zIndex: 1,
				  }
				: {};
		},
		childStyle() {
			return {
				top: "100px",
				right: "18px",
				zIndex: 9999,
				borderRadius: "5px",
				width: "100%",
				display: "flex",
				justifyContent: "flex-end",
				position: "absolute",
			};
		},
		// computedCriticalQueFailedData() {
		// 	let data = this.criticalQueFailedData;
		// 	// sort on 'failed_count' key
		// 	data.sort((a, b) => b.failed_count - a.failed_count);
		// 	data.forEach((e) => {
		// 		e.location = e.name;
		// 	});
		// 	data = data.filter((el) => el.failed_count > 0);
		// 	return data;
		// },
	},
	created() {
		this.byLocationDataLoading = true;
		this.formsDataLoading = true;
		this.performanceByLocationDataLoading = true;
		this.criticalDataLoading = true;
		this.topNonDataLoading = true;
		this.reportsDataLoading = true;
		this.listCountries();
		// this.checkCompany();
		// this.setInitialMonthToDate();
		const end = new Date();
		const start = new Date();
		start.setDate(1);
		this.dates = [start, end];
		this.mountType = true;
	},
	methods: {
		...mapActions("CommonStore", [
			"addDownloadingReportCountAction",
			"removeDownloadingReportCountAction",
		]),
		showPreviewByLocationAttachmentsMethods(arr, item) {
			this.storeObjImage = {};
			this.storeObjImage = item;
			this.fileURLArray = arr;
			this.viewType = "10";
		},
		getViewTypeEight() {
			this.viewType = "8";
			this.listTotalAverageGraphData(5);
		},
		getLocationDetailsPageMethod(item) {
			this.storeObj = {};
			this.storeObj = item;
			let start_date = moment(this.dates[0]).format("yyyy-MM-DD");
			let end_date = moment(this.dates[1]).format("yyyy-MM-DD");
			let params = {
				form_question_id: null,
				project_id: this.projectsTasks,
				location_id: item.basics,
				start_date: start_date,
				end_date: end_date,
				question_grade: "fail",
				project_status: null,
				critical_questions: true,
			};
			formBuilderServices.getNonCompliantQuestionDetails(params).then((res) => {
				this.ByLocationCriticalQuestionData = JSON.parse(res.data).data;
			});
			this.viewType = "9";
		},
		checkTypeToggleMethod(value) {
			this.checkTypeToggleValue = value;
		},
		changeRegion() {
			this.getViewType("form", "1");
		},
		checkCompany() {
			this.is_bt = JSON.parse(localStorage.getItem("check_company")).is_bt;
		},
		changeQuestionMethod(question) {
			this.storeObj = {};
			let obj = [...this.topNonComplaintsData].filter(
				(item) => item.basics == question
			)[0];
			this.storeObj = obj;
			this.$forceUpdate();
		},
		resetSelection(item) {
			const propertyMap = {
				category: "category",
				forms: "forms",
				question: "question",
				designation: "designation",
				user: "user",
				status: "status",
			};
			if (propertyMap[item.id]) {
				this[propertyMap[item.id]] = item.id === "status" ? "completed" : "All";
			}
			const index = this.selectedFilters.findIndex(
				(filter) => filter.name === item.name && filter.id === item.id
			);
			if (index !== -1) {
				this.selectedFilters.splice(index, 1);
			}
			this.listTotalAverageGraphData(0);
		},
		get_dashboard_response_MoMQoQ() {
			this.listTotalAverageGraphData(0);
			this.viewType = "1";
		},
		getNextActions() {
			this.currentStoreObject = JSON.parse(localStorage.getItem("storeObject"));
			this.storeObject = JSON.parse(localStorage.getItem("storeObject"));
			this.viewType = "4";
			this.$forceUpdate();
		},
		exportCSVTopNonComplaint() {
			this.addDownloadingReportCountAction("Report");
			let data = null;
			data = [...this.topNonComplaintsData].map((el) => {
				let item = {
					Questions: el.name,
					Critical: el.is_critical ? "Yes" : "No",
					Total: el.total,
					"Failed Response": el.failed_count,
					"Fail %": ((el.failed_count / el.total) * 100).toFixed(2) + "%",
				};
				return item;
			});
			const fileName = `Top Non Compliant Questions ${
				this.projectsTasksItems.length != 0
					? this.projectsTasksItems.filter((el) =>
							el.id.includes(this.projectsTasks)
					  )[0].name
					: "-"
			} ( ${this.moment(this.dates[0]).format("Do MMM YYYY")} - ${this.moment(
				this.dates[1]
			).format("Do MMM YYYY")} )`;
			const exportType = exportFromJSON.types.csv;
			exportFromJSON({ data, fileName, exportType });
			this.removeDownloadingReportCountAction();
		},
		exportCSV(type) {
			if (this.report_type == "Consolidated Report") {
				let data = null;
				if (type == 1) {
					data = [...this.reportsTable].map((el) => {
						let item = {
							"Location Id": el.store_id,
							Location: el.name,
							Region: el.region,
							"Sub Region": el.subregion,
							Occurence: el.total,
							Completed: el.completed,
						};
						if (this.showCompletion) {
							item["Completion %"] = el["completion_%"];
						}
						if (this.showScore) {
							item["Score Completion %"] = el["completed_score_%"];
							item["Total Points"] = el["completed_total_score"];
							item["Points Achieved"] = el["completed_current_score"];
							// item["Average Score"] = el["completed_score_%"];
						}
						return item;
					});
				}
				if (type == 2) {
					data = [...this.reportsTable].map((el) => {
						let item = {
							Location: el.name,
							Total: el.total,
						};
						if (this.showCompletion) {
							item["Completion %"] = el["completion_%"];
						}
						if (this.showScore) {
							item["Total Points"] = el["completed_total_score"];
							item["Points Achieved"] = el["completed_current_score"];
							item["Score %"] = el["completed_score_%"];
							// item["Average Score"] = el["completed_score_%"];
						}
						return item;
					});
				}
				const fileName = `Performance By Location ${
					this.projectsTasksItems.length != 0
						? this.projectsTasksItems.filter((el) =>
								el.id.includes(this.projectsTasks)
						  )[0].name
						: "-"
				} ( ${this.moment(this.dates[0]).format("Do MMM YYYY")} - ${this.moment(
					this.dates[1]
				).format("Do MMM YYYY")} )`;
				const exportType = exportFromJSON.types.csv;
				exportFromJSON({ data, fileName, exportType });
				this.removeDownloadingReportCountAction();
			}
			if (this.report_type == "Project / Task - Breakup Report") {
				var self = this;
				let data = [...self.reportsTable1].map((el) => {
					let item = {
						"Location Id": el.store_id,
						Location: el.store_name,
						"Project Start Date":
							el.project_start_date != 0
								? self.moment(el.project_start_date).format("Do MMM YYYY")
								: "-",
						"Project End Date":
							el.project_end_date != 0
								? self.moment(el.project_end_date).format("Do MMM YYYY")
								: "-",
						"Project Completion Date":
							el.project_completion_date != 0
								? self.moment
										.utc(el.project_completion_date)
										.local()
										.format("Do MMM YYYY")
								: "-",
						"Employee Id": el.emp_id,
						"Employee Name": el.name,
						Designation: el.designation,
						Region: el.region,
						"Sub Region": el.subregion,
						Status: el.status == "inprogress" ? "Incomplete" : "Completed",
						Grade: el.grade,
					};
					if (self.showCompletion) {
						item["Completion %"] = el["forms_completion_%"] + "%";
					}
					if (self.showScore) {
						item["Score Completion %"] = el["score_completion_%"];
						item["Points Available"] = el["total_score"];
						item["Points Achieved"] = el["current_score"];
						// item["Average Score"] = el["completed_score_%"] + "%";
					}
					return item;
				});
				const fileName = `Project / Task Breakup Reports ${
					self.projectsTasksItems.length != 0
						? self.projectsTasksItems.filter((el) =>
								el.id.includes(self.projectsTasks)
						  )[0].name
						: "-"
				} ( ${moment(self.dates[0]).format("Do MMM YYYY")} - ${moment(
					self.dates[1]
				).format("Do MMM YYYY")} )`;
				const exportType = exportFromJSON.types.csv;
				exportFromJSON({ data, fileName, exportType });
				self.removeDownloadingReportCountAction();
			}
		},
		showInDetailsQue(row) {
			// this.isShowDetailedQue = true;
			// this.$emit("showInDetailsQue", row);
			this.storeObj = row;
			this.viewType = "5";
		},
		handleDialogClose(done) {
			this.isShowDetailedQue = false;
			this.isShowSummaryDetails = false;
		},
		showSummaryDetails(type) {
			this.storeObj = type;
			this.viewType = "6";
		},
		toggleNonCompQueExtended() {
			this.is_non_comp_que_extended = !this.is_non_comp_que_extended;
		},
		async get_next_actions() {
			this.filterTotalAverage = "completed";
			this.selectedFilters = [];
			this.getDesignationAndUsers();
			await this.get_filelds_by_project();
			this.getCategory(this.projectsTasks);
			this.listTotalAverageGraphData(0);
		},
		// truncateLabel(label) {
		//     return label.length > 20 ? `${label.slice(0, 17)}...` : label;
		//     },
		async getViewTypeOne() {
			// this.showGraphbyCriticalQuestion = false;
			// if (this.viewType == "2") this.showScore = false;
			this.regionToggle = "All";
			await this.listTotalAverageGraphData(0);
			setTimeout(() => {
				this.viewType = "1";
				this.$forceUpdate();
			}, 10);
		},
		async getViewType(type, value) {
			// this.showGraphbyCriticalQuestion = false;
			if (type == "location") {
				await this.listTotalAverageGraphData(4);
				this.listTotalAverageGraphDataForBTTotalAverageGraphData();
				// await this.listByLocationData("expand");
				this.viewType = "2";
			}
			if (type == "form") {
				this.tableData = [];
				await this.listPerformanceByFormsSummary(value);
				await this.listPerformanceByFormsData(value);
				this.viewType = null;
				await this.listByFormsData(value);
				this.viewType = "3";
			}
			if (type == "compliant") {
				this.criticalDataLoading = true;
				this.viewType = "7";
				this.criticalDataLoading = false;
			}
			if (type == "critical") {
				await this.listTotalAverageGraphData(0);
				this.viewType = "8";
				// setTimeout(() => {
				// 	this.showGraphbyCriticalQuestion = true;
				// }, 100);
			}
			window.scroll(0, 0);
		},
		async listPerformanceByFormsSummary(value) {
			try {
				let start_date = moment(this.dates[0]).format("yyyy-MM-DD");
				let end_date = moment(this.dates[1]).format("yyyy-MM-DD");
				let user = this.user != "All" ? this.user : null;
				let designation = this.designation != "All" ? this.designation : null;
				let params = {};
				let lastElement = [];
				this.tableData = [];
				let lastIndex = 0;
				if (this.selectedLocationType == "region") {
					if (this.locations.length == 0) {
						this.locations = this.locationItems[0].id;
					} else {
						if (typeof this.locations != "string") {
							for (let i = 0; i < this.locations.length; i++) {
								for (let j = 0; j < this.locations[i].length; j++) {
									lastIndex = j;
								}
							}
							for (let i = 0; i < this.locations.length; i++) {
								for (let j = 0; j < this.locations[i].length; j++) {
									lastElement.push(this.locations[i][lastIndex]);
								}
							}
							lastElement = [...new Set(lastElement)].filter(Boolean);
						} else {
							lastElement = [this.locations];
							lastIndex = 0;
						}
					}
				} else {
					if (this.locationItems[0].id == this.locations) {
						this.locations = [];
					}
				}
				params = {
					filters: {
						outlets: lastIndex == 3 ? lastElement : [],
						countries: lastIndex == 0 ? lastElement : [],
						regions: lastIndex == 1 ? lastElement : [],
						subregions: lastIndex == 2 ? lastElement : [],
					},
					start_date: start_date,
					end_date: end_date,
					project: this.projectsTasks,
					form_category: this.category !== "All" ? this.category : null,
					form: this.forms !== "All" ? this.forms : null,
					form_question: this.question !== "All" ? this.question : null,
					basics: "form",
					include_dates: false,
					get_country_avg: false,
					aggregate_on: null,
					status: this.status !== "All" ? this.status : null,
					users: user != null ? [user] : [],
					designations: designation != null ? [designation] : [],
					include_outlets: false,
				};
				// if (this.viewBy == "location") params.basics = "outlet";
				// if (this.viewBy == "user") params.basics = "user";
				// if (this.selectedLocationType == "region") {
				// 	if (lastIndex == 0) params.basics = "region";
				// 	if (lastIndex == 1) params.basics = "subregion";
				// 	if (lastIndex == 2) params.basics = "outlet";
				// 	if (lastIndex == 3) params.basics = "outlet";
				// }
				if (value == "1")
					params.filters.regions =
						this.regionToggle != "All" ? [this.regionToggle] : [];
						if (this.selectedLocationType == "region"&&this.company_details.access_level != "admin") {
					params.filters = {
						outlets: [],
						countries: [],
						regions: [],
						subregions: [],
					};
				}
				formBuilderServices.getDashboardData(params).then((res) => {
					let FormsSummary = [];
					this.FormsSummary = [];
					FormsSummary = JSON.parse(res.data).data;
					// FormsSummary = [...FormsSummary].sort(
					// 	(a, b) => b.total_score - a.total_score
					// );
					this.FormsSummary = FormsSummary;
					this.$forceUpdate();
				});
			} catch (e) {
				console.log(e, "e");
			}
		},
		async listPerformanceByFormsData(value) {
			try {
				let start_date = moment(this.dates[0]).format("yyyy-MM-DD");
				let end_date = moment(this.dates[1]).format("yyyy-MM-DD");
				let user = this.user != "All" ? this.user : null;
				let designation = this.designation != "All" ? this.designation : null;
				let PerformanceFormsData = [];
				this.PerformanceFormsData = [];
				this.all_location_list = [];
				this.tableData = [];
				let params = {};
				let lastElement = [];
				let lastIndex = 0;
				if (this.selectedLocationType == "region") {
					if (this.locations.length == 0) {
						this.locations = this.locationItems[0].id;
					} else {
						if (typeof this.locations != "string") {
							for (let i = 0; i < this.locations.length; i++) {
								for (let j = 0; j < this.locations[i].length; j++) {
									lastIndex = j;
								}
							}
							for (let i = 0; i < this.locations.length; i++) {
								for (let j = 0; j < this.locations[i].length; j++) {
									lastElement.push(this.locations[i][lastIndex]);
								}
							}
							lastElement = [...new Set(lastElement)].filter(Boolean);
						} else {
							lastElement = [this.locations];
							lastIndex = 0;
						}
					}
				} else {
					if (this.locationItems[0].id == this.locations) {
						this.locations = [];
					}
				}
				params = {
					filters: {
						outlets: lastIndex == 3 ? lastElement : [],
						countries: lastIndex == 0 ? lastElement : [],
						regions: lastIndex == 1 ? lastElement : [],
						subregions: lastIndex == 2 ? lastElement : [],
					},
					start_date: start_date,
					end_date: end_date,
					project: this.projectsTasks,
					form_category: this.category !== "All" ? this.category : null,
					form: this.forms !== "All" ? this.forms : null,
					form_question: this.question !== "All" ? this.question : null,
					basics: "form",
					include_dates: false,
					get_country_avg: false,
					aggregate_on: null,
					status: this.status !== "All" ? this.status : null,
					users: user != null ? [user] : [],
					designations: designation != null ? [designation] : [],
					include_outlets: true,
				};
				if (value == "1")
					params.filters.regions =
						this.regionToggle != "All" ? [this.regionToggle] : [];
						if (this.selectedLocationType == "region"&&this.company_details.access_level != "admin") {
					params.filters = {
						outlets: [],
						countries: [],
						regions: [],
						subregions: [],
					};
				}
				const res = await formBuilderServices.getDashboardData(params);

				PerformanceFormsData = JSON.parse(res.data).data;
				PerformanceFormsData = [...PerformanceFormsData].sort(
					(a, b) => b.total_score - a.total_score
				);
				this.PerformanceFormsData = PerformanceFormsData;
				const groupedArrays = [];
				const groupedByNames = {};
				for (const obj of this.PerformanceFormsData) {
					const name = obj.name;
					if (!groupedByNames[name]) {
						groupedByNames[name] = {
							name,
							arr: [],
							last_occurance_order: "",
							last_completion_order: "",
							last_score_order: "",
							scores: [], // Array to store score_completion_% values
						};
						groupedArrays.push(groupedByNames[name]);
					}
					groupedByNames[name].arr.push(obj);
					if (obj["score_completion_%"]) {
						groupedByNames[name].scores.push(obj["score_completion_%"]);
					}
				}
				if (groupedArrays.length) {
					groupedArrays[0].arr.forEach((el) => {
						this.all_location_list.push({
							name: el.name,
							location: el.location,
							basics: el.basics,
							total: el.total,
							completed: el.completed,
							"completion_%": el["completion_%"],
							"score_completion_%": el["score_completion_%"],
						});
					});
				}
				this.all_location_list = [...this.all_location_list].sort((a, b) =>
					a.location.localeCompare(b.location)
				);
				this.tableData = groupedArrays;
				this.$forceUpdate();
			} catch (e) {
				console.log(e, "e");
			}
		},
		groupByNames() {
			// this.mom_table_data.sort((a, b) => {
			// 	const dateA = new Date(a.date.split("-").reverse().join("-"));
			// 	const dateB = new Date(b.date.split("-").reverse().join("-"));
			// 	return dateA - dateB;
			// });
			// this.view_month_table = true;
			// this.isDomLoading = false;
			// this.show_report = true;
		},
		get_detailed_report_actions() {
			this.report_type = "Consolidated Report";
			this.DialogDetailedReport = false;
			this.listReportsSwitchData();
			this.$forceUpdate();
		},
		listReportsSwitchData() {
			if (this.report_type == "Detailed Report") {
				this.DialogDetailedReport = true;
				this.report_type = "Consolidated Report";
			} else {
				this.listTotalAverageGraphData(0);
			}
		},
		setInitialMonthToDate() {
			const end = new Date();
			const start = new Date();
			start.setDate(1);
			this.dates = [start, end];
		},
		getQuestions(id) {
			if (this.forms == "All") this.question = "";
			if (this.forms != "All") this.question = "All";
			this.questionItems = [];
			formBuilderServices
				.getQuestionsList(id != "All" ? id : "")
				.then((res) => {
					this.questionItems = JSON.parse(res.data).data;
					this.questionItems.unshift({ name: "All", id: "All" });
					if (this.forms != "All") {
						const selectedItem = this.formItems.find((item) => item.id === id);
						if (selectedItem) {
							const existingCategoryIndex = this.selectedFilters.findIndex(
								(item) => item.id === "forms"
							);
							if (existingCategoryIndex !== -1) {
								this.selectedFilters.splice(existingCategoryIndex, 1, {
									name: selectedItem.name,
									id: "forms",
								});
							} else {
								this.selectedFilters.push({
									name: selectedItem.name,
									id: "forms",
								});
							}
						}
					} else {
						const selectedFilterNames = this.selectedFilters.map(
							(item) => item.name
						);
						const indexesToRemove = [];
						selectedFilterNames.forEach((name, index) => {
							if (this.formItems.some((item) => item.name === name)) {
								indexesToRemove.push(index);
							}
						});
						indexesToRemove.reverse().forEach((index) => {
							this.selectedFilters.splice(index, 1);
						});
					}
				});
		},
		clear_filters(type) {
			this.category = "All";
			this.forms = "All";
			this.question = "All";
			this.designation = "All";
			this.user = "All";
			this.status = "completed";
			if (type == 1) this.showMoreFilters = false;
		},
		checkCondition(type, id) {
			if (type == "Question") {
				if (this.forms == "All") this.question = "";
				if (this.forms != "All") this.question = "All";
				if (this.question != "All") {
					const selectedItem = this.questionItems.find(
						(item) => item.id === id
					);
					if (selectedItem) {
						const existingCategoryIndex = this.selectedFilters.findIndex(
							(item) => item.id === "question"
						);
						if (existingCategoryIndex !== -1) {
							this.selectedFilters.splice(existingCategoryIndex, 1, {
								name: selectedItem.name,
								id: "question",
							});
						} else {
							this.selectedFilters.push({
								name: selectedItem.name,
								id: "question",
							});
						}
					}
				} else {
					const selectedFilterNames = this.selectedFilters.map(
						(item) => item.name
					);
					const indexesToRemove = [];
					selectedFilterNames.forEach((name, index) => {
						if (this.questionItems.some((item) => item.name === name)) {
							indexesToRemove.push(index);
						}
					});
					indexesToRemove.reverse().forEach((index) => {
						this.selectedFilters.splice(index, 1);
					});
				}
			}
			if (type == "Designation") {
				if (this.designation == "All") this.user = "";
				if (this.designation != "All") this.user = "All";
				this.user = "All";
				this.userItems = [];
				let userItems;
				if (this.designation != "All") {
					userItems = [...this.userItems1].filter(
						(item) => item.designation_id == this.designation
					);
				} else {
					userItems = [...this.userItems1];
				}

				this.userItems = userItems;
				this.userItems.unshift({ full_name: "All", id: "All" });
				if (this.designation != "All") {
					const selectedItem = this.designationItems.find(
						(item) => item.id === id
					);
					if (selectedItem) {
						const existingCategoryIndex = this.selectedFilters.findIndex(
							(item) => item.id === "designation"
						);
						if (existingCategoryIndex !== -1) {
							this.selectedFilters.splice(existingCategoryIndex, 1, {
								name: selectedItem.full_name,
								id: "designation",
							});
						} else {
							this.selectedFilters.push({
								name: selectedItem.full_name,
								id: "designation",
							});
						}
					}
				} else {
					const selectedFilterNames = this.selectedFilters.map(
						(item) => item.name
					);
					const indexesToRemove = [];
					selectedFilterNames.forEach((name, index) => {
						if (this.designationItems.some((item) => item.full_name === name)) {
							indexesToRemove.push(index);
						}
					});
					indexesToRemove.reverse().forEach((index) => {
						this.selectedFilters.splice(index, 1);
					});
				}
			}
			if (type == "User") {
				if (this.user != "All") {
					const selectedItem = this.userItems.find((item) => item.id === id);
					if (selectedItem) {
						const existingCategoryIndex = this.selectedFilters.findIndex(
							(item) => item.id === "user"
						);
						if (existingCategoryIndex !== -1) {
							this.selectedFilters.splice(existingCategoryIndex, 1, {
								name: selectedItem.full_name,
								id: "user",
							});
						} else {
							this.selectedFilters.push({
								name: selectedItem.full_name,
								id: "user",
							});
						}
					}
				} else {
					const selectedFilterNames = this.selectedFilters.map(
						(item) => item.name
					);
					const indexesToRemove = [];
					selectedFilterNames.forEach((name, index) => {
						if (this.userItems.some((item) => item.full_name === name)) {
							indexesToRemove.push(index);
						}
					});
					indexesToRemove.reverse().forEach((index) => {
						this.selectedFilters.splice(index, 1);
					});
				}
			}
			if (type == "Status") {
				if (this.status != "All") {
					const selectedItem = this.statusItems.find((item) => item.id === id);
					if (selectedItem) {
						const existingCategoryIndex = this.selectedFilters.findIndex(
							(item) => item.id === "status"
						);
						if (existingCategoryIndex !== -1) {
							this.selectedFilters.splice(existingCategoryIndex, 1, {
								name: selectedItem.name,
								id: "status",
							});
						} else {
							this.selectedFilters.push({
								name: selectedItem.name,
								id: "status",
							});
						}
					}
				} else {
					const selectedFilterNames = this.selectedFilters.map(
						(item) => item.name
					);
					const indexesToRemove = [];
					selectedFilterNames.forEach((name, index) => {
						if (this.statusItems.some((item) => item.name === name)) {
							indexesToRemove.push(index);
						}
					});
					indexesToRemove.reverse().forEach((index) => {
						this.selectedFilters.splice(index, 1);
					});
				}
			}
		},
		getForms(id) {
			if (this.category == "All") this.forms = "";
			if (this.category != "All") this.forms = "All";
			this.question = "";
			this.formItems = [];

			formBuilderServices.getFormsList(id != "All" ? id : "").then((res) => {
				this.formItems = JSON.parse(res.data).data;
				this.formItems.unshift({ name: "All", id: "All" });
				if (this.category != "All") {
					const selectedItem = this.categoryItems.find(
						(item) => item.id === id
					);
					if (selectedItem) {
						const existingCategoryIndex = this.selectedFilters.findIndex(
							(item) => item.id === "category"
						);
						if (existingCategoryIndex !== -1) {
							this.selectedFilters.splice(existingCategoryIndex, 1, {
								name: selectedItem.name,
								id: "category",
							});
						} else {
							this.selectedFilters.push({
								name: selectedItem.name,
								id: "category",
							});
						}
					}
				} else {
					const selectedFilterNames = this.selectedFilters.map(
						(item) => item.name
					);
					const indexesToRemove = [];
					selectedFilterNames.forEach((name, index) => {
						if (this.categoryItems.some((item) => item.name === name)) {
							indexesToRemove.push(index);
						}
					});
					indexesToRemove.reverse().forEach((index) => {
						this.selectedFilters.splice(index, 1);
					});
				}
			});
		},

		async get_filelds_by_project() {
			return new Promise((resolve, reject) => {
				try {
					this.showFields = this.projectsTasksItems
						.filter((el) => el.id == this.projectsTasks)
						.map((el) => el.show_fields);
					this.showCompletion = false;
					this.showScore = false;
					for (let i = 0; i < this.showFields.length; i++) {
						if (this.showFields[i].includes("score_%")) {
							this.showScore = true;
						} else if (this.showFields[i].includes("completion_%")) {
							this.showCompletion = true;
						}
						if (this.showScore && this.showCompletion) {
							break; // Exit the loop early if both conditions are met
						}
					}
					this.$forceUpdate();
					resolve();
				} catch (error) {
					reject(error);
				}
			});
		},
		async getCategory(id) {
			try {
				this.category = "All";
				this.categoryItems = [];
				const res = await formBuilderServices.getCategoryList(id);
				this.categoryItems = JSON.parse(res.data).data;
				this.categoryItems.unshift({ name: "All", id: "All" });
			} catch (error) {
				console.error("Error in getCategory:", error);
			}
		},
		getDesignationAndUsers() {
			let start_date = moment(this.dates[0]).format("yyyy-MM-DD");
			let end_date = moment(this.dates[1]).format("yyyy-MM-DD");
			let params = {
				project: this.projectsTasks,
				filters: {},
				start_date: start_date,
				end_date: end_date,
			};
			formBuilderServices.getDesignationAndUsersList(params).then((res) => {
				this.designationItems = JSON.parse(res.data).designations;
				this.userItems = JSON.parse(res.data).users;
				this.userItems1 = JSON.parse(res.data).users;
				this.designationItems.unshift({ name: "All", id: "All" });
				this.userItems.unshift({ name: "All", id: "All" });
				// this.user = "";
				// this.designation = "All";
			});
		},
		async listProjectsAndTasks() {
			formBuilderServices.getProjectsTasksList().then(async (res) => {
				let projectsTasksItems = JSON.parse(res.data).data;
				this.projectsTasksItems = projectsTasksItems.sort(
					(a, b) => a.serial_no - b.serial_no
				);
				if (this.projectsTasksItems.length != 0) {
					this.projectsTasks = this.projectsTasksItems[0].id;
					await this.get_filelds_by_project();
					this.getDesignationAndUsers();
					await this.getCategory(this.projectsTasks);
					this.listTotalAverageGraphData(0);
				}
			});
		},
		async listActionPlan() {
			this.actionPlanData = [];
			try {
				let projectsTasks =
					this.projectsTasksItems.length != 0
						? this.projectsTasksItems.filter((el) =>
								el.id.includes(this.projectsTasks)
						  )[0].name
						: "-";
				let params = {
					filters: {
						outlets: this.locations,
					},
					search: "",
					projects_list: [projectsTasks],
					submitted_by_list: [],
					designation_list: [],
					grade_list: [],
					status_list: [],
					sort_on: "",
					sort_by: "",
				};
				const res = await formBuilderServices.listActionsPage1(1, 5, params);
				console.log(JSON.parse(res.data).data, "resss");
				this.actionPlanData = JSON.parse(res.data).data;
			} catch (e) {
				console.log(e, "err");
			}
		},
		listTopNonComplaintData() {
			this.topNonDataLoading = true;
			let start_date = moment(this.dates[0]).format("yyyy-MM-DD");
			let end_date = moment(this.dates[1]).format("yyyy-MM-DD");
			let user = this.user != "All" ? this.user : null;
			let designation = this.designation != "All" ? this.designation : null;
			let params = {};
			let lastElement = [];
			let lastIndex = 0;
			this.topNonComplaintsData = [];
			if (this.selectedLocationType == "region") {
				if (this.locations.length == 0) {
					this.locations = this.locationItems[0].id;
				} else {
					if (typeof this.locations != "string") {
						for (let i = 0; i < this.locations.length; i++) {
							for (let j = 0; j < this.locations[i].length; j++) {
								lastIndex = j;
							}
						}
						for (let i = 0; i < this.locations.length; i++) {
							for (let j = 0; j < this.locations[i].length; j++) {
								lastElement.push(this.locations[i][lastIndex]);
							}
						}
						lastElement = [...new Set(lastElement)].filter(Boolean);
					} else {
						lastElement = [this.locations];
						lastIndex = 0;
					}
				}
			} else {
				if (this.locationItems[0].id == this.locations) {
					this.locations = [];
				}
			}
			params = {
				filters: {
					outlets: lastIndex == 3 ? lastElement : [],
					countries: lastIndex == 0 ? lastElement : [],
					regions: lastIndex == 1 ? lastElement : [],
					subregions: lastIndex == 2 ? lastElement : [],
				},
				start_date: start_date,
				end_date: end_date,
				project: this.projectsTasks,
				form_category: this.category !== "All" ? this.category : null,
				form: this.forms !== "All" ? this.forms : null,
				form_question: this.question !== "All" ? this.question : null,
				basics: "form_question",
				include_dates: false,
				get_country_avg: false,
				aggregate_on: null,
				status: "completed",
				users: user != null ? [user] : [],
				designations: designation != null ? [designation] : [],
				// question_grade: "fail",
			};
			// if (this.viewBy == "location") params.basics = "outlet";
			// if (this.viewBy == "user") params.basics = "user";
			// if (this.selectedLocationType == "region") {
			// 	if (lastIndex == 0) params.basics = "region";
			// 	if (lastIndex == 1) params.basics = "subregion";
			// 	if (lastIndex == 2) params.basics = "outlet";
			// 	if (lastIndex == 3) params.basics = "outlet";
			// }
			if (this.selectedLocationType == "region"&&this.company_details.access_level != "admin") {
					params.filters = {
						outlets: [],
						countries: [],
						regions: [],
						subregions: [],
					};
				}
			formBuilderServices.getDashboardData(params).then((res) => {
				let topNonComplaintsData = [];

				topNonComplaintsData = JSON.parse(res.data).data;
				topNonComplaintsData = [...topNonComplaintsData].sort(
					(a, b) => b.failed_count - a.failed_count
				);
				topNonComplaintsData = [...topNonComplaintsData].filter(
					(el) => el.failed_count != 0
				);
				this.topNonComplaintsData = topNonComplaintsData;

				// this.isDomLoading = false;
				this.topNonDataLoading = false;

				this.$forceUpdate();
			});
		},
		listConsolidatedData() {
			let start_date = moment(this.dates[0]).format("yyyy-MM-DD");
			let end_date = moment(this.dates[1]).format("yyyy-MM-DD");
			let user = this.user != "All" ? this.user : null;
			let designation = this.designation != "All" ? this.designation : null;
			let params = {};
			let lastElement = [];
			let lastIndex = 0;
			if (this.selectedLocationType == "region") {
				if (this.locations.length == 0) {
					this.locations = this.locationItems[0].id;
				} else {
					if (typeof this.locations != "string") {
						for (let i = 0; i < this.locations.length; i++) {
							for (let j = 0; j < this.locations[i].length; j++) {
								lastIndex = j;
							}
						}
						for (let i = 0; i < this.locations.length; i++) {
							for (let j = 0; j < this.locations[i].length; j++) {
								lastElement.push(this.locations[i][lastIndex]);
							}
						}
						lastElement = [...new Set(lastElement)].filter(Boolean);
					} else {
						lastElement = [this.locations];
						lastIndex = 0;
					}
				}
			} else {
				if (this.locationItems[0].id == this.locations) {
					this.locations = [];
				}
			}
			params = {
				filters: {
					outlets: lastIndex == 3 ? lastElement : [],
					countries: lastIndex == 0 ? lastElement : [],
					regions: lastIndex == 1 ? lastElement : [],
					subregions: lastIndex == 2 ? lastElement : [],
				},
				start_date: start_date,
				end_date: end_date,
				project: this.projectsTasks,
				form_category: this.category !== "All" ? this.category : null,
				form: this.forms !== "All" ? this.forms : null,
				form_question: this.question !== "All" ? this.question : null,
				basics: "country",
				include_dates: false,
				get_country_avg: false,
				aggregate_on: null,
				status: this.status !== "All" ? this.status : null,
				users: user != null ? [user] : [],
				designations: designation != null ? [designation] : [],
			};
			// if (this.viewBy == "location") params.basics = "outlet";
			// if (this.viewBy == "user") params.basics = "user";
			// if (this.selectedLocationType == "region") {
			// 	if (lastIndex == 0) params.basics = "region";
			// 	if (lastIndex == 1) params.basics = "subregion";
			// 	if (lastIndex == 2) params.basics = "outlet";
			// 	if (lastIndex == 3) params.basics = "outlet";
			// }
			if (this.selectedLocationType == "region"&&this.company_details.access_level != "admin") {
					params.filters = {
						outlets: [],
						countries: [],
						regions: [],
						subregions: [],
					};
				}
			formBuilderServices.getDashboardData(params).then((res) => {
				let TotalCountryData = [];
				this.TotalCountryData = [];
				TotalCountryData = JSON.parse(res.data).data;
				TotalCountryData = [...TotalCountryData].sort(
					(a, b) => b.total_score - a.total_score
				);
				this.TotalCountryData = TotalCountryData;
				this.showGraphByCountry = true;
				this.isDomLoading = false;
				this.$forceUpdate();
			});
		},
		async listByFormsData(value) {
			this.formsDataLoading = true;
			this.showGraphByForms = false;
			try {
				let start_date = moment(this.dates[0]).format("yyyy-MM-DD");
				let end_date = moment(this.dates[1]).format("yyyy-MM-DD");
				let user = this.user != "All" ? this.user : null;
				let designation = this.designation != "All" ? this.designation : null;
				let params = {};
				let lastElement = [];
				let lastIndex = 0;
				if (this.selectedLocationType == "region") {
					if (this.locations.length == 0) {
						this.locations = this.locationItems[0].id;
					} else {
						if (typeof this.locations != "string") {
							for (let i = 0; i < this.locations.length; i++) {
								for (let j = 0; j < this.locations[i].length; j++) {
									lastIndex = j;
								}
							}
							for (let i = 0; i < this.locations.length; i++) {
								for (let j = 0; j < this.locations[i].length; j++) {
									lastElement.push(this.locations[i][lastIndex]);
								}
							}
							lastElement = [...new Set(lastElement)].filter(Boolean);
						} else {
							lastElement = [this.locations];
							lastIndex = 0;
						}
					}
				} else {
					if (this.locationItems[0].id == this.locations) {
						this.locations = [];
					}
				}
				params = {
					filters: {
						outlets: lastIndex == 3 ? lastElement : [],
						countries: lastIndex == 0 ? lastElement : [],
						regions: lastIndex == 1 ? lastElement : [],
						subregions: lastIndex == 2 ? lastElement : [],
					},
					start_date: start_date,
					end_date: end_date,
					project: this.projectsTasks,
					form_category: this.category !== "All" ? this.category : null,
					form: this.forms !== "All" ? this.forms : null,
					form_question: this.question !== "All" ? this.question : null,
					basics: "form",
					include_dates: false,
					get_country_avg: false,
					aggregate_on: null,
					// status: "completed",
					status: this.status !== "All" ? this.status : null,
					users: user != null ? [user] : [],
					designations: designation != null ? [designation] : [],
				};
				// if (this.viewBy == "location") params.basics = "outlet";
				// if (this.viewBy == "user") params.basics = "user";
				// if (this.selectedLocationType == "region") {
				// 	if (lastIndex == 0) params.basics = "region";
				// 	if (lastIndex == 1) params.basics = "subregion";
				// 	if (lastIndex == 2) params.basics = "outlet";
				// 	if (lastIndex == 3) params.basics = "outlet";
				// }
				if (value == "1")
					params.filters.regions =
						this.regionToggle != "All" ? [this.regionToggle] : [];
						if (this.selectedLocationType == "region"&&this.company_details.access_level != "admin") {
					params.filters = {
						outlets: [],
						countries: [],
						regions: [],
						subregions: [],
					};
				}
				formBuilderServices.getDashboardData(params).then((res) => {
					let TotalFormsData = [];
					this.TotalFormsData = [];
					TotalFormsData = JSON.parse(res.data).data;
					console.log(TotalFormsData, "TotalFormsData");
					if (this.showScore) {
						TotalFormsData = [...TotalFormsData].sort(
							(a, b) => b.total_score - a.total_score
						);
					} else {
						TotalFormsData = [...TotalFormsData].sort(
							(a, b) => b["completion_%"] - a["completion_%"]
						);
					}

					this.TotalFormsData = TotalFormsData;
					setTimeout(() => {
						this.formsDataLoading = false;
						this.showGraphByForms = true;
					}, 100);
					this.$forceUpdate();
				});
			} catch (e) {
				console.log(e, "error");
			}
		},
		async listByLocationData(type) {
			this.performanceByLocationDataLoading = true;
			this.showGraphByLocationexpanded = false;
			this.showGraphByLocation = false;
			try {
				let start_date = moment(this.dates[0]).format("yyyy-MM-DD");
				let end_date = moment(this.dates[1]).format("yyyy-MM-DD");
				let user = this.user != "All" ? this.user : null;
				let designation = this.designation != "All" ? this.designation : null;
				let params = {};
				let lastElement = [];
				let lastIndex = 0;
				if (this.selectedLocationType == "region") {
					if (this.locations.length == 0) {
						this.locations = this.locationItems[0].id;
					} else {
						if (typeof this.locations != "string") {
							for (let i = 0; i < this.locations.length; i++) {
								for (let j = 0; j < this.locations[i].length; j++) {
									lastIndex = j;
								}
							}
							for (let i = 0; i < this.locations.length; i++) {
								for (let j = 0; j < this.locations[i].length; j++) {
									lastElement.push(this.locations[i][lastIndex]);
								}
							}
							lastElement = [...new Set(lastElement)].filter(Boolean);
						} else {
							lastElement = [this.locations];
							lastIndex = 0;
						}
					}
				} else {
					if (this.locationItems[0].id == this.locations) {
						this.locations = [];
					}
				}
				params = {
					filters: {
						outlets: lastIndex == 3 ? lastElement : [],
						countries: lastIndex == 0 ? lastElement : [],
						regions: lastIndex == 1 ? lastElement : [],
						subregions: lastIndex == 2 ? lastElement : [],
					},
					start_date: start_date,
					end_date: end_date,
					project: this.projectsTasks,
					form_category: this.category !== "All" ? this.category : null,
					form: this.forms !== "All" ? this.forms : null,
					form_question: this.question !== "All" ? this.question : null,
					basics: "outlet",
					include_dates: false,
					get_country_avg: false,
					aggregate_on: null,
					// status: "completed",
					status: this.status !== "All" ? this.status : null,
					users: user != null ? [user] : [],
					designations: designation != null ? [designation] : [],
				};
				if (this.viewBy == "location") params.basics = "outlet";
				if (this.viewBy == "user") params.basics = "user";
				// if (this.selectedLocationType == "region") {
				// 	if (lastIndex == 0) params.basics = "region";
				// 	if (lastIndex == 1) params.basics = "subregion";
				// 	if (lastIndex == 2) params.basics = "outlet";
				// 	if (lastIndex == 3) params.basics = "outlet";
				// }
				if (this.selectedLocationType == "region"&&this.company_details.access_level != "admin") {
					params.filters = {
						outlets: [],
						countries: [],
						regions: [],
						subregions: [],
					};
				}
				formBuilderServices.getDashboardData(params).then((res) => {
					let TotalByLocationData = [];
					this.TotalByLocationData = [];
					TotalByLocationData = JSON.parse(res.data);
					if (this.viewByPerformance == "Top") {
						if (this.showScore) {
							TotalByLocationData = [...TotalByLocationData.data].sort(
								(a, b) => b["completed_score_%"] - a["completed_score_%"]
							);
						} else {
							TotalByLocationData = [...TotalByLocationData.data].sort(
								(a, b) => b["completion_%"] - a["completion_%"]
							);
						}
					} else {
						if (this.showScore) {
							TotalByLocationData = [...TotalByLocationData.data].sort(
								(a, b) => a["completed_score_%"] - b["completed_score_%"]
							);
						} else {
							TotalByLocationData = [...TotalByLocationData.data].sort(
								(a, b) => a["completion_%"] - b["completion_%"]
							);
						}
					}
					if (type == "expand") {
						this.TotalByLocationData = TotalByLocationData;
						this.showGraphByLocationexpanded = true;
					}
					if (type == "expand4") {
						this.reportsTable = [];
						this.TotalByLocationData = TotalByLocationData;
						this.reportsTable = this.TotalByLocationData;
						this.showGraphByLocationexpanded = true;
					}
					if (type == "only_five") {
						this.TotalByLocationData = TotalByLocationData.slice(0, 5);
						setTimeout(() => {
							this.showGraphByLocation = true;
						}, 100);
					}
					this.performanceByLocationDataLoading = false;
					this.$forceUpdate();
				});
			} catch (e) {
				console.log(e, "err");
			}
		},
		async listTotalAverageGraphData(type) {
			this.byLocationDataLoading = true;
			this.formsDataLoading = true;
			this.performanceByLocationDataLoading = true;
			this.criticalDataLoading = true;
			this.topNonDataLoading = true;
			this.reportsDataLoading = true;

			try {
				this.showScore = false;
				this.is_outlet = false;
				let start_date = moment(this.dates[0]).format("yyyy-MM-DD");
				let end_date = moment(this.dates[1]).format("yyyy-MM-DD");
				let user = this.user != "All" ? this.user : null;
				let designation = this.designation != "All" ? this.designation : null;
				let params = {};
				let lastElement = [];
				let lastIndex = 0;
				this.reportsTable = [];
				this.reportsTable1 = [];
				this.summaryData = [];
				this.counryAverage = [];
				this.SummaryreportsTable = [];
				this.TotalAverageGraphData = [];
				this.criticalQuestionsData = [];
				this.showGraph = false;
				// this.showGraphbyCriticalQuestion = false;
				if (this.selectedLocationType == "region") {
					if (this.locations.length == 0) {
						this.locations = this.locationItems[0].id;
					} else {
						if (typeof this.locations != "string") {
							for (let i = 0; i < this.locations.length; i++) {
								for (let j = 0; j < this.locations[i].length; j++) {
									lastIndex = j;
								}
							}
							for (let i = 0; i < this.locations.length; i++) {
								for (let j = 0; j < this.locations[i].length; j++) {
									lastElement.push(this.locations[i][lastIndex]);
								}
							}
							lastElement = [...new Set(lastElement)].filter(Boolean);
						} else {
							lastElement = [this.locations];
							lastIndex = 0;
						}
					}
				} else if (this.selectedLocationType == "location") {
					if (this.locationItems[0].id == this.locations) {
						this.locations = [];
					} else {
						lastIndex = 3;
						lastElement = this.locations;
					}
					// else{
					// 	lastElement = [this.locations];
					// }
				}
				params = {
					filters: {
						outlets: lastIndex == 3 ? lastElement : [],
						countries: lastIndex == 0 ? lastElement : [],
						regions: lastIndex == 1 ? lastElement : [],
						subregions: lastIndex == 2 ? lastElement : [],
					},
					start_date: start_date,
					end_date: end_date,
					project: this.projectsTasks,
					form_category: this.category !== "All" ? this.category : null,
					form: this.forms !== "All" ? this.forms : null,
					form_question: this.question !== "All" ? this.question : null,
					basics: "",
					include_dates: false,
					get_country_avg: true,
					// status: this.status !== "All" ? this.status : null,
					status: "completed",
					users: user != null ? [user] : [],
					designations: designation != null ? [designation] : [],
				};
				if (this.viewBy == "location") params.basics = "outlet";
				if (this.viewBy == "user") params.basics = "user";

				this.report_type == "Consolidated Report"
					? (params.basics = "outlet")
					: (params.basics = "user"),
					this.report_type == "Consolidated Report"
						? (params.include_dates = false)
						: (params.include_dates = true);
				if (type == 4) params.basics = "outlet";
				if (this.selectedLocationType == "region" && type != 4) {
					if (lastIndex == 0) params.basics = "region";
					if (lastIndex == 1) params.basics = "subregion";
					if (lastIndex == 2) params.basics = "outlet";
					if (lastIndex == 3) params.basics = "outlet";
				}
				if (
					this.selectedLocationType == "region" &&
					type != 4 &&
					this.report_type == "Project / Task - Breakup Report"
				) {
					params.basics = "user";
				}
				this.regionType = lastIndex;
				if (this.selectedLocationType == "region"&&this.company_details.access_level != "admin") {
					params.filters = {
						outlets: [],
						countries: [],
						regions: [],
						subregions: [],
					};
				}
				// Calling API for Locations - Critical Questions Failed

				formBuilderServices.getDashboardData(params).then((res) => {
					let TotalAverageGraphData = [];
					TotalAverageGraphData = JSON.parse(res.data);
					this.summaryData = TotalAverageGraphData.summary;
					this.TotalAverageGraphData = TotalAverageGraphData.data;
					this.TotalAverageGraphData = [...this.TotalAverageGraphData].sort(
						(a, b) => b["completed_score_%"] - a["completed_score_%"]
					);
					if (this.report_type == "Project / Task - Breakup Report") {
						let reportsTable1 = JSON.parse(res.data).data;
						this.reportsTable1 = reportsTable1.sort(
							(a, b) =>
								moment(a.project_start_date).format("x") -
								moment(b.project_start_date).format("x")
						);
						this.showProjTasks = true;
					}
					this.reportsTable = this.TotalAverageGraphData;
					this.SummaryreportsTable[0] = TotalAverageGraphData.country_average;
					if (!this.showScore && !this.showCompletion) {
						this.get_filelds_by_project();
					}
					// for (let i = 0; i < this.showFields.length; i++) {
					// 	if (this.showFields[i].includes("score_%")) {
					// 		this.showScore = true;
					// 	}
					// 	if (this.showFields[i].includes("completion_%")) {
					// 		this.showCompletion = true;
					// 	}
					// }
					if (this.showScore) {
						this.filterTotalAverageItems = [];
						this.counryAverage =
							TotalAverageGraphData.country_average["completed_score_%"];
						this.filterTotalAverageItems = [
							{ name: "Completed Count", id: "completed" },
							{ name: "Average Score %", id: "average" },
							{ name: "Score", id: "score" },
						];
						if (this.mountType) {
							this.filterTotalAverage = "completed";
						}
					}
					if (this.showCompletion) {
						this.filterTotalAverageItems = [];
						this.counryAverage =
							TotalAverageGraphData.country_average["completion_%"];
						this.filterTotalAverageItems = [
							{ name: "Completed Count", id: "completed" },
							{ name: "Completion %", id: "completion" },
						];
						if (this.mountType) {
							this.filterTotalAverage = "completed";
						}
					}
					if (this.selectedLocationType == "location") {
						this.is_outlet = true;
					}
					if (lastIndex == 2 || lastIndex == 3) {
						this.is_outlet = true;
					}
					// if (!this.is_bt) {
					// 	this.showGraph = true;
					// }
					if (type == 0) {
						if (this.showScore) {
							this.listTopNonComplaintData();
						}
						if (this.viewByLocation == "Consolidated")
							this.listConsolidatedData();
						this.listByLocationData("only_five");
						// this.listActionPlan();
						this.listByFormsData();
					}
					if (type == 2) {
						this.listByLocationData("expand");
					}
					if (type == 3) {
						if (this.viewByPerformance == "Top") {
							this.reportsTable = [...this.reportsTable].sort(
								(a, b) => b["completed_score_%"] - a["completed_score_%"]
							);
						} else {
							this.reportsTable = [...this.reportsTable].sort(
								(a, b) => a["completed_score_%"] - b["completed_score_%"]
							);
						}
					}
					if (type == 4) {
						if (this.viewByPerformance == "Top") {
							this.reportsTable = [...this.reportsTable].sort(
								(a, b) => b["completed_score_%"] - a["completed_score_%"]
							);
						} else {
							this.reportsTable = [...this.reportsTable].sort(
								(a, b) => a["completed_score_%"] - b["completed_score_%"]
							);
						}
						this.listByLocationData("expand4");
						// this.showGraph = false;
					}
					if (this.is_bt) {
						this.listTotalAverageGraphDataForBTTotalAverageGraphData();
					} else {
						setTimeout(() => {
							this.showGraph = true;
						}, 100);
					}
					this.mountType = false;
					if (type == 0 || type == 5) {
						if (this.showScore) {
							this.listLocationCriticalQuestionsFailedData(params);
						}
					}
					this.byLocationDataLoading = false;
					this.reportsDataLoading = false;

					// this.$forceUpdate();
					// if (this.selectedLocationType == "region") {
					// 	this.listTotalAverageGraphDataForBTTotalAverageGraphData();
					// }
				});
			} catch (e) {
				console.log(e, "err");
			}
		},
		async listLocationCriticalQuestionsFailedData(params) {
			this.criticalDataLoading = true;
			this.criticalQuestionsData = [];
			this.showGraphbyCriticalQuestion = false;
			try {
				let payload = JSON.parse(JSON.stringify(params));
				payload.basics = "outlet";
				payload.for_critical_questions = true;
				payload.status = null;
				payload.question_grade = null;
				if (this.selectedLocationType == "region"&&this.company_details.access_level != "admin") {
					payload.filters = {
						outlets: [],
						countries: [],
						regions: [],
						subregions: [],
					};
				}
				const res = await formBuilderServices.getDashboardData(payload);

				this.criticalQuestionsData = JSON.parse(res.data).data;
				let criticalQuestionsData = this.criticalQuestionsData.filter(
					(el) => el.failed_count != 0
				);
				criticalQuestionsData = criticalQuestionsData.sort(
					(a, b) => b.failed_count - a.failed_count
				);
				this.criticalQuestionsData = criticalQuestionsData;
				this.criticalQueFailedSummaryData = JSON.parse(
					res.data
				).country_average;
				this.showGraphbyCriticalQuestion = true;
				this.criticalDataLoading = false;
				this.$forceUpdate();
			} catch (e) {
				console.log(e, "e");
			}
		},
		async listTotalAverageGraphDataForBTTotalAverageGraphData() {
			try {
				this.showGraph = false;
				let start_date = moment(this.dates[0]).format("yyyy-MM-DD");
				let end_date = moment(this.dates[1]).format("yyyy-MM-DD");
				let user = this.user != "All" ? this.user : null;
				let designation = this.designation != "All" ? this.designation : null;
				let params = {};
				let lastElement = [];
				let lastIndex = 0;
				this.summaryData = [];
				this.TotalAverageGraphData = [];

				if (this.selectedLocationType == "region") {
					if (this.locations.length == 0) {
						this.locations = this.locationItems[0].id;
					} else {
						if (typeof this.locations != "string") {
							for (let i = 0; i < this.locations.length; i++) {
								for (let j = 0; j < this.locations[i].length; j++) {
									lastIndex = j;
								}
							}
							for (let i = 0; i < this.locations.length; i++) {
								for (let j = 0; j < this.locations[i].length; j++) {
									lastElement.push(this.locations[i][lastIndex]);
								}
							}
							lastElement = [...new Set(lastElement)].filter(Boolean);
						} else {
							lastElement = [this.locations];
							lastIndex = 0;
						}
					}
				} else if (this.selectedLocationType == "location") {
					if (this.locationItems[0].id == this.locations) {
						this.locations = [];
					} else {
						lastIndex = 3;
						lastElement = this.locations;
					}
					// else{
					// 	lastElement = [this.locations];
					// }
				}
				params = {
					filters: {
						outlets: lastIndex == 3 ? lastElement : [],
						countries: lastIndex == 0 ? lastElement : [],
						regions: lastIndex == 1 ? lastElement : [],
						subregions: lastIndex == 2 ? lastElement : [],
					},
					start_date: start_date,
					end_date: end_date,
					project: this.projectsTasks,
					form_category: this.category !== "All" ? this.category : null,
					form: this.forms !== "All" ? this.forms : null,
					form_question: this.question !== "All" ? this.question : null,
					basics: "region",
					include_dates: false,
					get_country_avg: true,
					status: this.status !== "All" ? this.status : null,
					users: user != null ? [user] : [],
					designations: designation != null ? [designation] : [],
				};
				if (this.selectedLocationType == "region"&&this.company_details.access_level != "admin") {
					params.filters = {
						outlets: [],
						countries: [],
						regions: [],
						subregions: [],
					};
				}
				formBuilderServices.getDashboardData(params).then((res) => {
					let TotalAverageGraphData = [];
					TotalAverageGraphData = JSON.parse(res.data);
					this.summaryData = TotalAverageGraphData.summary;
					this.TotalAverageGraphData = TotalAverageGraphData.data;
					this.TotalAverageGraphData = [...this.TotalAverageGraphData].sort(
						(a, b) => b["completed_score_%"] - a["completed_score_%"]
					);
					this.SummaryreportsTable[0] = TotalAverageGraphData.country_average;
					setTimeout(() => {
						this.showGraph = true;
					}, 100);
				});
			} catch (e) {
				console.log(e, "err");
			}
		},
		listCountries() {
			this.allLocations = [];
			formBuilderServices.getCountryList().then((res) => {
				this.locationItems = JSON.parse(res.data).results;
				console.log(this.locationItems, "ietms");
				this.locationItems.forEach((el) => {
					el.label = el.name;
					el.value = el.id;
					if (el.children && el.children.length != 0) {
						el.regions = el.children;
						el.regions.forEach((elR) => {
							elR.label = elR.name;
							elR.value = elR.id;
							if (elR.children.length != 0) {
								elR.subregions = elR.children;
								elR.subregions.forEach((elS) => {
									elS.label = elS.name;
									elS.value = elS.id;
									if (elS.children.length != 0) {
										elS.outlet = elS.children;
										elS.outlet.forEach((elO) => {
											elO.label = elO.name;
											elO.value = elO.id;
										});
									}
								});
							}
						});
					} else {
						el.children = el.regions;
						el.children.forEach((elR) => {
							elR.label = elR.name;
							elR.value = elR.id;
							if (elR.subregions.length != 0) {
								elR.children = elR.subregions;
								elR.children.forEach((elS) => {
									elS.label = elS.name;
									elS.value = elS.id;
									if (elS.outlets.length != 0) {
										elS.children = elS.outlets;
										elS.children.forEach((elO) => {
											elO.label = elO.name;
											elO.value = elO.id;
										});
									}
								});
							}
						});
					}
				});
				this.regionListItem = [
					...(this.locationItems[0].children
						? this.locationItems[0].children
						: this.locationItems[0].regions),
				];
				this.regionListItem.unshift({ name: "All", id: "All" });
				this.listProjectsAndTasks();
			});
			formBuilderServices.listAllLocations().then((res) => {
				let allLocations = JSON.parse(res.data);
				this.allLocations = allLocations.sort((a, b) =>
					a.name < b.name ? -1 : 1
				);
			});
		},
		onClickHandler(picker) {
			this.datePickerType = "monthrange";
			setTimeout(() => {
				this.$nextTick(() => {
					this.$refs.datePickerRef.focus();
				});
			}, 100);
		},
		async handlePickerClose(val) {
			if (val == "1") {
				await this.listTotalAverageGraphData(0);
			}
			if (val == "2") {
				this.listByLocationData("expand");
			}
			if (val == "3") {
				await this.listPerformanceByFormsData(0);
				setTimeout(() => {
					this.listByFormsData();
					this.viewType = "3";
				}, 500);
			}
		},
		toggleMoreFilters() {
			this.showMoreFilters = !this.showMoreFilters;
		},
		apply_filters() {
			this.listTotalAverageGraphData(0);
			this.showMoreFilters = !this.showMoreFilters;
		},
	},
};
</script>

<style>
.el-dialog.ns-dialog-que-details .el-dialog__header {
	background-color: #f6f7f9;
	padding: 0px;
}
.el-dialog.ns-dialog-que-details .el-dialog__header {
	background-color: #f6f7f9;
	padding: 0px;
}
.el-dialog.ns-dialog-que-details .el-dialog__body {
	background-color: #f6f7f9;
	padding: 15px 20px 30px 20px;
}
.el-dialog.ns-dialog-que-details {
	background-color: #f6f7f9;
}
.el-dialog.ns-dialog-que-details .el-dialog__close {
	display: none !important;
}
.top-non-complaint-table .ns-top-non-comp-tbl th,
.top-non-complaint-table .ns-top-non-comp-tbl td {
	padding: 10px 10px !important;
}
</style>

<style lang="scss">
.dashboard {
	background-color: #f6f7f9;
	width: 100%;
	margin: auto;
	.top-non-complaint-table {
		background-color: #ffffff;
		color: #333333;
		font-family: inherit !important;
		text-transform: none !important;
		text-align: left !important;
		width: 100% !important;
		.el-table th.el-table__cell > .cell {
			text-align: left !important;
			color: #333333 !important;
			text-transform: capitalize !important;
		}
		tbody tr td {
			text-align: left !important;
		}
		.el-table tr {
			background-color: #fff;
			border-bottom: 1px solid #ebeef5;
			font-size: 13px;
			text-align: left !important;
		}
		.el-table__body-wrapper {
			overflow-y: auto;
			min-height: 43vh;
			max-height: 43vh;
		}
	}
	.critical-questions-falied-table {
		background-color: #ffffff;
		color: #333333;
		font-family: inherit !important;
		text-transform: none !important;
		text-align: left !important;
		width: 100% !important;
		.el-table th.el-table__cell > .cell {
			text-align: left !important;
			color: #333333 !important;
			text-transform: capitalize !important;
		}
		tbody tr td {
			text-align: left !important;
		}
		.el-table tr {
			background-color: #fff;
			border-bottom: 1px solid #ebeef5;
			font-size: 13px;
			text-align: left !important;
		}
		.el-table__body-wrapper {
			overflow-y: auto;
			min-height: 44vh;
			max-height: 44vh;
		}
	}
	.reports-table-hide {
		background-color: #ffffff;
		color: #333333;
		font-family: inherit !important;
		text-transform: none !important;
		text-align: left !important;
		.el-table th.el-table__cell > .cell {
			text-align: left !important;
			color: #333333 !important;
			text-transform: none !important;
		}
		tbody tr td {
			text-align: left !important;
		}
		.el-table tr {
			background-color: #fff;
			border-bottom: 1px solid #ebeef5;
			font-size: 13px;
			text-align: left !important;
		}
		.el-table__body-wrapper {
			overflow-y: auto;
			display: none;
		}
		.el-table__empty-block {
			display: none !important;
		}
	}
	.reports-table {
		background-color: #ffffff;
		color: #333333;
		font-family: inherit !important;
		text-transform: none !important;
		text-align: left !important;
		.el-table th.el-table__cell > .cell {
			text-align: left !important;
			color: #333333 !important;
			text-transform: none !important;
		}
		tbody tr td {
			text-align: left !important;
		}
		.el-table tr {
			background-color: #fff;
			border-bottom: 1px solid #ebeef5;
			font-size: 13px;
			text-align: left !important;
		}
		.el-table__body-wrapper {
			overflow-y: auto;
			min-height: 35vh;
			max-height: 35vh;
		}
		.el-table__empty-block {
			display: none !important;
		}
	}
	.reports-table-consolidated {
		background-color: #ffffff;
		color: #333333;
		font-family: inherit !important;
		text-transform: none !important;
		text-align: left !important;
		width: 100% !important;
		.el-table th.el-table__cell > .cell {
			text-align: left !important;
			color: #333333 !important;
			text-transform: capitalize !important;
		}
		tbody tr td {
			text-align: left !important;
		}
		.el-table tr {
			background-color: #fff;
			border-bottom: 1px solid #ebeef5;
			font-size: 13px;
			text-align: left !important;
		}
		.el-table__body-wrapper {
			overflow-y: auto;
			min-height: 54vh;
			max-height: 54vh;
		}
	}
	.reports-table1 {
		background-color: #ffffff;
		color: #333333;
		font-family: inherit !important;
		text-transform: none !important;
		text-align: left !important;
		.el-table th.el-table__cell > .cell {
			text-align: left !important;
			color: #333333 !important;
			text-transform: none !important;
		}
		tbody tr td {
			text-align: left !important;
		}
		.el-table thead.is-group th.el-table__cell {
			background: white !important;
		}
		.el-table tr {
			background-color: #fff;
			border-bottom: 1px solid #ebeef5;
			font-size: 13px;
			text-align: left !important;
		}
		.el-table__body-wrapper {
			overflow-y: auto;
			overflow-x: auto;
			min-height: 62vh;
			max-height: 62vh;
		}
	}
	.reports-tableNonCompliant {
		background-color: #ffffff;
		color: #333333;
		font-family: inherit !important;
		text-transform: none !important;
		text-align: left !important;
		.el-table th.el-table__cell > .cell {
			text-align: left !important;
			color: #333333 !important;
			text-transform: none !important;
		}
		tbody tr td {
			text-align: left !important;
		}
		.el-table thead.is-group th.el-table__cell {
			background: white !important;
		}
		.el-table tr {
			background-color: #fff;
			border-bottom: 1px solid #ebeef5;
			font-size: 13px;
			text-align: left !important;
		}
		.el-table__body-wrapper {
			overflow-y: auto;
			overflow-x: auto;
			min-height: 66vh;
			max-height: 66vh;
		}
	}
}

.el-select.select {
	border-radius: 12px !important;
	width: 100%;
}
.el-select.select .el-input {
	border-radius: 12px !important;
	width: 100%;
	height: 35px;
}
.el-select.select .el-input .el-input__inner {
	border-radius: 12px !important;
	width: 100%;
	font-size: 12px;
	height: 35px;
	line-height: 35px;
	padding-right: 30px;
}
.el-select.select .el-input .el-input__suffix {
	right: 10px;
	top: 60%;
	transform: translateY(-50%);
	pointer-events: none;
}
.filter-card {
	width: 30%;
	padding: 20px;
	border: 1px solid #dcdcdc;
	border-radius: 5px;
	background-color: #f9f9f9;
	margin-top: 10px;
}
.button-class-new {
	height: 35px;
	background: #f9a168;
	border-radius: 12px;
	color: #ffffff;
	display: flex;
	align-items: center;
	justify-content: center;
}
.button-class-new2 {
	height: 35px;
	background: #d26300;
	border-radius: 12px;
	color: #ffffff;
	display: flex;
	align-items: center;
	justify-content: center;
}
.el-date-editor.el-input__inner {
	border-radius: 12px !important;
	width: 100% !important;
	font-size: 12px !important;
	height: 35px !important;
	line-height: 35px !important;
}
.el-date-editor .el-range-input {
	font-size: 12px !important;
}
.el-picker-panel .el-picker-panel__sidebar {
	width: 200px !important;
	font-size: 12px !important;
}
.el-picker-panel [slot="sidebar"] + .el-picker-panel__body,
.el-picker-panel__sidebar + .el-picker-panel__body {
	margin-left: 210px;
}
.el-cascader {
	position: relative; /* Ensure it fits within the container */
	width: 100% !important; /* Make the cascader take up the full width of its container */
}
.el-cascader__tags .el-tag {
	overflow: hidden;
	text-overflow: ellipsis;
}
.el-cascader .el-input .el-input__inner {
	cursor: pointer;
	border-radius: 12px !important;
	font-size: 12px !important;
	height: 35px !important;
	line-height: 35px !important;
	padding-right: 10px !important;
	white-space: nowrap; /* Prevent text wrapping */
	overflow: hidden; /* Hide overflow */
	width: "90%" !important;
	text-overflow: ellipsis; /* Show ellipsis for overflow text */
}
.el-cascader__search-input {
	text-transform: capitalize;
	font-size: 12px !important;
	height: 0px !important;
}
.custom-dropdown {
	z-index: 10000 !important; /* Ensure the dropdown appears above other elements */
}
.searchicon {
	padding-left: 20px;
	height: 35px;
	border-radius: 12px;
	border: none;
	width: 100%;
	background: #ffffff
		url("https://static.thenounproject.com/png/101791-200.png") no-repeat;
	background-size: 15px;
	background-position: -webkit-calc(100% - 20px) center;
	-webkit-transition: 0.5s;
	transition: 0.5s;
	outline: none;
	border: 1px solid rgb(209, 203, 203);
}
.ns-one {
	width: 300px !important;
	font-weight: normal;
	color: black;
	max-height: 274px;
	text-overflow: ellipsis;
}
.ns-one.selected {
	color: #409eff;
	font-weight: 700;
}
.el-tag.el-tag--warning {
	background-color: #fdf6ec;
	border-color: #f9a168;
	color: black;
	border-radius: 12px;
}
.no-data-card {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 310px; /* Set a height to ensure vertical centering */
	border: none;
	background-color: white;
}
.no-data-text {
	text-align: center;
	color: #d26300;
	font-size: 16px;
	font-weight: bold;
}
.container {
	display: flex;
	flex-wrap: wrap;
	width: 100%;
	gap: 1%;
}

.card-container {
	flex: 1 1 calc(50% - 1%);
	box-sizing: border-box;
	margin-top: 5px;
}

.card {
	border-radius: 6px;
}

.card-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	margin-bottom: 0px;
	padding: 0 30px;
}

.toggle-container {
	display: flex;
	align-items: center;
}

.toggle {
	cursor: pointer;
	margin: 0 10px;
}

.toggle.active {
	color: #d26300;
	font-weight: 550;
}

.view-more {
	display: flex;
	justify-content: flex-end;
	margin-right: 50px;
	text-decoration: underline;
	color: #d26300;
	cursor: pointer;
}

.no-data-card {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 310px; /* Set a height to ensure vertical centering */
	border: none;
	background-color: white;
}

.no-data-text {
	color: #d26300;
	font-size: 16px;
	font-weight: bold;
}
</style>
<!-- .el-select-dropdown .el-select-dropdown__list {
	white-space: normal !important;
	max-width: 300px;
	width: unset !important;
	text-overflow: ellipsis;
}

.el-select-dropdown .el-select-dropdown__item span {
	white-space: normal !important;
	word-wrap: break-word;
	text-overflow: ellipsis;
} -->
